export default {

  "More": "opciónes",

  "Change Vehicle": "cambiar vehículo",

  "Assigned Truck": "vehículo asignado",

  "VIN": "VIN",

  "Year": "año",

  "Manufacturer": "fabricante",

  "Model": "modelo",

  "Accept": "aceptar",

  "Please provide Cycle Details": "Proporcione los detalles del ciclo",

  "Vehicle Type": "Tipo de vehículo",

  "Property": "propiedad",

  "Passenger": "pasajero",

  "Cycle Rule": "Regla de ciclo",

  "USA 70 Hour \/ 8 day": "USA 70 horas \/ 8 días",

  "USA 60 Hour \/ 7 day": "USA 60 horas \/ 7 días",

  "Local Radius": "radio local",

  "Exceptions": "exepciones",

  "30 Minute Break Exception": "Excepción de 30 minutos de descanso",

  "24 hour cycle": "Ciclo de 24 horas",

  "Fuel Tracker": "seguidor de combustible",

  "Fuel Amount (enter amount in gallons)": "cantidad de combustible (en galones)",

  "Odometer": "Odómetro",

  "Total Cost": "costo de combustible",

  "Receipt": "copia del recibo",

  "View Policies": "Pólizas y Procedimientos",

  "Please Read and Sign Policies and Procedures": "Sur firma es comprobación que usted a leído estas paginas",

  "Driving Training": "Entrenamiento de nuevos choferes",

  "Accident Investigation": "Investigación de Accidentes",

  "Inspection": "Inspecciones de Seguridad",

  "Driver Selection MVR": "conformidad con MVR",

  "Distraction Free Driving": "póliza sobre el uso de Teléfonos celulares",

  "PSP Usage": "Uso de la PSP",

  "Loss Control Manual": "Manual de control de pérdidas",

  "Email used to send Missing Information": "Mail para enviar información que falta",

  "Edit Signature": "Modificar firma",

  "Clear Signature": "borrar firma",

  "Company Info": "Información sobre la compañía",

  "Name": "Nombre",

  "ID": "carné de identidad",

  "Contact Person": "Persona de contacto",

  "Address": "dirección",

  "Phone": "número de teléfono",

  "Website": "sitio web",

  "Contact Person 2": "Persona de contacto 2",

  "Phone 2": "número de teléfono 2",

  "Address 2": "dirección 2",

  "Rate the App": "Evaluar la Aplicación",

  "Share the App": "Compartir la Aplicación",

  "Settings": "Ajustos",

  "Time Zone": "zona horaria",

  "Cycle Rule": "Reglas de Circulación",

  "Exceptions": "excepciónes",

  "Enter Unit ID or VIN number": "Introduzca el número de unidad o el número de serie del vehículo",

  "You do not have a vehicle assigned": "USTED NO TIENE UN VEHÍCULO ASIGNADO",

  "vehicleOrFMsearch": "Utilizar BUSCAR para encontrar un vehículo o póngase en contacto con su gerente de flota.",

  "Back": "regresa",

  "Enter Location": "Indicar ubicacion",

  "Your Location": "Su localidad",

  "Remarks": "Observaciones",

  "Time Left": "Tiempo Restante",

  "Break": "Descanso",

  "Time Remaining until Break": "Tiempo restante para descanso",

  "Cycle": "Ciclo",

  "Cycle Time Remaining": "Tiempo restante en ciclo",

  "On Duty": "empezar a trabajar",

  "ON_DUTY": "DE SERVICIO",

  "Off Duty": "para de trabajar",

  "OFF_DUTY": "FUERA DE SERVICIO",

  "On Duty Time Remaining": "Tiempo de trabajo restante",

  "HOS (Hours of Service)": "Horas de servicio",

  "Miles": "Millas",

  "Hours": "Horas",

  "hours": "horas",

  "Hours worked today": "Horas trabajadas hoy",

  "Hours Available Today": "Horas Disponible hoy",

  "Hours Available Tomorrow": "Horas Disponibles manana",

  "Expand": "Extender",

  "Dashboard": "Panel de control",

  "Sleeping": "Durmiendo",

  "Edit": "Editar",

  "Sign": "Firmar",

  "Driver": "Conductor",

  "Carrier": "Portador",

  "Vehicles": "Vehículos",

  "Trailers": "Remolques",

  "From": "De",

  "To": "Hasta",

  "Main": "Principal",

  "Home": "Casa",

  "Ship Docs": "Documentos De Barco",

  "Notes": "Notas",

  "Tap to Edit Log": "Toque para editar registro",

  "Begin New Inspection": "Empezar Inspeccion nueva",

  "DVIR": "DVIR",

  "DOT": "DOT",

  "Front": "Frente",

  "Headlights": "Faros",

  "Flashers": "Luces Interminentes",

  "Fog Lights": "Faros Antiniebla",

  "Marker Lights": "Luces de posicion",

  "Engine Compartment": "Compartimiento del motor",

  "Fluids": "Fluidos",

  "Belts": "Cinturones",

  "Hoses": "Mangueras",

  "Compressor": "Compresor",

  "Brakes": "Frenos",

  "Steering": "Gobierno",

  "Suspension": "Suspension",

  "Proceed to Curbside Front Axle": "Continuar con el Eje delantero de Curbside",

  "Defect": "Defecto",

  "Enter Defect Description": "Introduzca la descripción del defecto",

  "Enter Odometer Reading": "Ingrese la lectura del cuentakilómetros",

  "Mirrors": "Espejos",

  "Tires": "Llantas",

  "Wheels": "Ruedas",

  "Curbside Rear Axle": "Eje trasero de la acera",

  "Proceed to Rear": "Proceder a la parte trasera",

  "Driver Rear Axle": "Eje trasero controlador",

  "Driver Front Axle": "Eje delantero controlador",

  "Cab": "Taxi",

  "Horn": "Bocina",

  "Fire Extinguisher": "Extindor de incendios",

  "Wipers\/Washers": "Limpia parabrisas",

  "Triangles": "Triangulos",

  "Haz Mat Book": "Libro de Hazmat",

  "DOT Paperwork": "Tramites de puntos",

  "Brakes Bleed Down Test": "Prueba de Purga de los Frenos",

  "Test Parking Brakes": "Prueba de Frenos de estacionamiento",

  "Brakes Test Stop 1st Rotation of Wheels": "Frenos Prueba de detener la primera rotación de las ruedas",

  "Assess Vehicle Conditions": "Evaluar Las condiciones del vehiculo",

  "Unsatisfactory": "Insatisfactorio",

  "Satisfactory": "Satisfactorio",

  "Sign and Save Report": "Firmar y Guardar Reporte",

  "Send All": "Mandar Todo",

  "Record Violations": "Violaciones de registro",

  "Inspect Logs\/DVIRS": "Inspeccionar los registros",

  "Email Logs and DVIR": "Mandar registros via correo electronico",

  "Create Inspection Report": "Crear reporte de inspeccion",

  "Record": "Record",

  "Take Photo": "Tomar foto",

  "Finish Inspection": "Terminar Inspeccion",

  "Inspect Documents": "Inspeccionar Documentos",

  "Pull Over to Safe Location": "Detenerse a un lugar seguro",

  "Do not Admit Fault": "No admitir Culpa",

  "Check for Injuries": "Revisar por lesiones",

  "Please Confirm that you have been involved in an accident or press cancel to return to the dashboard": "Por favor confirmar que no a estado incolucrado en accidentes o presionar cancelar para regresar a la pagina principal",

  "Injuries-Call 911": "Lesiones- Llamar al 911",

  "Step 1\/5": "Pasos 1 al 5",

  "Take photos of all 4 corners of each vehicle and 2 photos of the accident scene": "Tomar fotos de las cuatro ezquinas del vehiculo y dos fotos de la escena del accidente",

  "broadview": "Vista Amplia",

  "broadview 2": "Vista Amplia 2",

  "driver front": "Frente del conductor",

  "passenger front": "Del acompanante",

  "driver rear": "Trasera del conductor",

  "passenger rear": "Trasera del acompanante",

  "other vehicle and property damage": "Otro vehiculo y dano a la propiedad",

  "Example: Guard rail, signs, light pole, etc. add # of photos needed": "Ejemplo:  Pasamanos, Poste de Luz, etc. Agregar # de fotos necesarias",

  "identifyAllParties": "Es importante identificar a todas las partes involucradas y recopilar su información de inmediato. Si no hay testigos, haga clic en continuar.",

  "Important: Get statements from all witnesses": "Importante: Obtenga declaraciones de testigos",

  "add party involved": "Anadir las partes involucradas",

  "Add Witness": "Anadir testigo",

  "other driver": "otro conductor",

  "passenger": "Pasajero",

  "passenger of other vehicle": "Pasajero de otro vehiculo",

  "witness": "Testigo",

  "full name": "Nombre Completo",

  "address": "Direccion",

  "city": "Ciudad",

  "state": "Estado",

  "driver license number": "Numero de Licensia",

  "insurance information": "Informacion de la aseguranza",

  "audio statement": "Audio de Declaracion",

  "describe the following": "Describa lo siguiente",

  "Vehicles involved, what happened, speed limit, time of day, weather, road conditions": "Vehiculos involucrados, que paso, Limite de velocidad, hora del dia, estado del tiempo, condiciones de la carretera",

  "Driver Statement": "Declaracion del conductor",

  "Police Report": "Reporte policial",

  "Report Number": "Numero de Reporte",

  "Officer Name": "Nombre del official",

  "Phone": "Telefono",

  "Badge Number": "Numero de Distintivo",

  "Police Report Photo": "Foto de reporte policial",

  "Finish": "Terminar",

  "signLogbook": "Esta operando fuera de conformidad. Por favor firme su diario.",

  "You did not complete your pre-trip DVIR before you started driving": "No completó su antes del viaje DVIR antes de empezar a conducir",

  "maintance": "mantenimiento",

  "type": "tipo",

  "reported": "reportado",

  "status": "estado",

  "view inspection report": "ver informe de inspeccion",

  "view photos": "ver fotos",

  "scheduled start date": "fecha de inicio programada",

  "scheduled due date": "Fecha de finalizacion prevista",

  "search vehicles": "buscar vehiculo",

  "History": "Historial",

  "change signature": "cambiar(editar) firma",

  "please provide your signature": "por favor proporcionar firma",

  "edit signature": "editar firma",

  "Loss control manual": "Manual de control de pérdidas",

  "accident investigation": "investigacion de accidente",

  "Inspection": "Inspeccion",

  "Driver Selection MVR": "MVR seleccion del controlador",

  "Name": "Nombre",

  "Address": "Direccion",

  "Phone": "Telefono",

  "contact person": "Persona de Contacto",

  "Other address": "Otra direccion",

  "Other phone": "otro telefono",

  "Other contact person": "Otra persona de contacto",

  "Website": "Sitio Web",

  "Vehicle search": "buscar vehiculos",

  "Odometer": "Odometro",

  "Headlights": "Faros",

  "Flashers": "Luces Interminentes",

  "Fog lights": "faros antiniebla",

  "Marker Lights": "Luces de posicion",

  "Engine compartment": "compartimiento del motor",

  "Fluids": "Fluidos",

  "hoses": "mangueras",

  "compressor": "compresor",

  "brakes": "frenos",

  "steering": "gobierno",

  "suspension": "suspension",

  "my vehicles": "mis vehículos",

  "Leave comments": "Dejar comentarios",

  "change driver": "cambiar conductor",

  "Exit": "Salir",

  "New Work Orders": "Ordenes nuevas de trabajo",

  "service type": "tipo de servicio",

  "view policies": "Ver políticas",

  "Company info": "información de negocio",

  "Send Feedback": "Enviar comentarios",

  "Share the app": "Comparte la aplicación",

  "settings": "Ajustes",

  "logout": "Cerrar sesión",

  "Not Started": "no empezado",

  "In Progress": "en progreso",

  "Awaiting Parts": "Esperando partes",

  "done": "hecho",

  "cost": "Costo",

  "receipt": "recibo",

  "Repair": "reparar",

  "Safety Repair": "Reparación de seguridad",

  "Switch to Driver": "Cambiar al el conductor",

  "Dashboard Page": "Página del panel",

  "Company Summary": "sumario de la compañía",

  "Total Drivers": "Total de Conductores",

  "On Duty": "empezar a trabajar",

  "Driving": "manejando",

  "DRIVING": "MANEJANDO",

  "Sleeping": "Durmiendo",

  "Off Duty": "para de trabajar",

  "Total Trucks": "numero de vehículos",

  "In Shop": "en el taller",

  "Out of Service": "Fuera de servicio",

  "Logs-": "Registros",

  "Users": "usuarios",

  "Accidents": "Acidentes",

  "Repair and Maintenance": "Reparamientos y Mantenimiento",

  "Inspections": "Inspeciones",

  "Reports": "Reportes",

  "Manage Logs": "Administrar registros",

  "Date From": "Fecha de",

  "View": "Ver",

  "Clear": "Borrar",

  "Hours Worked": "Horas Trabajadas",

  "Distance": "Distancia",

  "Cycle Rule": "Regla de ciclo",

  "Tools": "Herramientas",

  "Address": "Direccion",

  "Telephone": "telefono",

  "Online": "En linea",

  "Users": "Usarios",

  "Manage Users": "Administrar usuarios",

  "Search User": "Buscar Usuario",

  "Add New User": "Agregar Usuario",

  "Import User": "importación usuario",

  "Full Name": "Nombre Completo",

  "Role": "Función",

  "Hire Date": "Fecha de Contratacion",

  "Assigned Vehicles": "Vehiculos Asignados",

  "Documents": "Documentos",

  "Joined": "unido",

  "Last Drug Test": "Último examen de drogas",

  "Last Login": "Última conexión",

  "Quick Filters": "Filtors Rapidos",

  "Mechanics": "Mecanicos",

  "Fleet Managers": "Gestion de flotas",

  "Admins": "Administradores",

  "All": "Todos",

  "Search Vehicle": "Buscar Vehiculo",

  "Add new vehicle": "Agregar vehiculo",

  "Add New Trailer": "Agregar Traila Nueva",

  "List of Vehicles": "Lista de Vehiculos",

  "Drivers": "Conductores",

  "Year": "Ano",

  "Manufacturer": "fabricante",

  "Model": "Modelo",

  "Accidents-": "Accidentes",

  "Manage Accidents": "Gestion de los accidentes",

  "Photos": "Fotos",

  "Driver Statement": "Declaracion de Conductor",

  "Witness Statement": "Declaracion de testigo",

  "Accident Report": "Reporte de Accidente",

  "Date and Time": "Fecha y Hora",

  "Repair and Maintenance-": "Reparación y mantenimiento",

  "Manage Work Orders": "Gestionar las ordenes de trabajo",

  "Search Work Order": "busqueda de orden de trabajo",

  "Repair Cost": "Costo de Reparamiento",

  "Service Type": "Tipo de Servicio",

  "Inspections": "Inspecciones",

  "View Report": "Ver Reporte",

  "Driver’s Vehicle Inspection Report-": "Informe de inspección de vehículos de motor",

  "Odometer": "Odometro",

  "Carrier": "Provedor",

  "Location": "Ubicacion",

  "No defects Found": "No se encontraron defectos",

  "Defects have been corrected": "Los defectos han sido corregidos",

  "Repairs not needed for safe operation of the vehicle": "Reparamientos no necesarios para la operacion del vehiculo",

  "User Main Informacion": "Informacion Principal del usuario",

  "First name": "Nombre",

  "Last name": "Apellido",

  "Cell Phone": "Teléfono celular",

  "Reset Password": "Reprogramar Contrasena",

  "Password": "Contrasena",

  "Confirm Password": "Confirmar Contrasena",

  "Safety Fleet Management-": "Gestión de la flota de seguridad",

  "Alerts": "Alertas",

  "Date": "Fecha",

  "Drivers On Duty": "Conductores trabajando",

  "View More": "Ver Mas",

  "Daily Logs": "Registros diarios",

  "Hours Driving": "Horas conduciendo",

  "Potential Violations": "Violaciones Potenciales",

  "Violation Type": "Tipo de infracción",

  "Recent Accidents": "Accidentes Recientes",

  "Quick Filters": "Filtros rápidos",

  "Full name": "Nombre Completo",

  "Hire Date": "Fecha de Contratacion",

  "Documents": "Documentos",

  "Please fill in atleast one assigned driver and its corresponding annotation": "Por favor rellene al menos un conductor asignado y su anotación correspondiente",

  "Please fill in atleast one assigned driver and its corresponding annotation": "Por favor rellene al menos un conductor asignado y su notas correspondiente",

  "Joined": "Unido",

  "Last Drug Test": "Último examen de drogas",

  "Company Data": "Datos de la compañia",

  "Company": "Compañía",

  "Dot #": "Numero de DOT",

  "Maintenance Period(months)": "Periodo de Mantenimiento (meses)",

  "Maintenance Mileage": "Millaje de Mantenimiento",

  "Contract Expiration Date": "Fecha de Vencimiento de Contrato",

  "Current Subscription Cost": "Precio Actual de Subscripcion",

  "Number of Trucks": "Número de vehículos",

  "Home Time Zone": "Horario de Casa",

  "Main Information": "Informacion Principal",

  "Company Logo": "Logotipo de la compañía",

  "choosePngJpg": "Por favor escoja format .png o jpg",

  "Select Policies": "Seleccionar políticas",

  "Driver Training": "Entrenamiento de conductor",

  "Training Days": "Dias de Entrenamiento",

  "Hours of Training to be completed annually": "Horas de entrenamiento requeridas anualmente",

  "Accident Investigation": "Investigacion de Acidentes",

  "Full name of Safety Manager": "Nombre de Gerente de seguridad",

  "Driver Selection And MVR": "Seleccion de Conductores y Historial de manejo",

  "Maximum number of accidents": "Numero maximo de accidents",

  "Maximum allowable number of citations": "Numero maximo de incidentes permitidos",

  "Minimum years on similar equipment": "Anos de experiencia en equipo similar",

  "Distraction Free Driving": "Conducción libre de distracción",

  "Driving Training": "Entrenamiento de nuevos choferes",

  "Accident Investigation": "Investigación de Accidentes",

  "Inspection": "Inspecciones de Seguridad",

  "Driver Selection and MVR": "Seleccion de Conductores y Historial de manejo",

  "Distraction Free Driving": "póliza sobre el uso de Teléfonos celulares",

  "FRONT": "Frente",

  "CURBSIDE REAR AXLE": "Eje trasero de la acera",

  "DRIVER REAR AXLE": "Eje trasero controlador",

  "DRIVER FRONT AXLE": "Eje delantero controlador",

  "Brakes": "Frenos",

  "Tires": "Llantas",

  "Training Days": "Dias de Entrenamiento",

  "Hours of Training to be Completed Annually": "Horas de entrenamiento requeridas anualmente",

  "Full Name of Safety Manager": "Nombre de Gerente de seguridad",

  "Maximum number of accidents": "Numero maximo de accidents",

  "Maximum allowable number of citations": "Numero maximo de incidentes permitidos",

  "Minimum years on similar equipment": "Anos de experiencia en equipo similar",

  "Property": "propiedad",

  "Passenger": "pasajero",

  "Not Started": "no empezado",

  "Awaiting Parts": "Esperando partes",

  "In Progress": "en progreso",

  "Repair": "reparar",

  "Safety repair": "Reparación de seguridad",

  "Total Cost": "costo de combustible",

  "Cost": "Costo",

  "Remarks": "Observaciones",

  "Location": "Ubicacion",

  "Date": "Fecha",

  "Date": "Fecha",

  "Hours Worked": "Horas Trabajadas",

  "Distance": "Distancia",

  "Cycle Rule": "Regla de ciclo",

  "Satisfactory": "Satisfactorio",

  "Unsatisfactory": "Insatisfactorio",

  "Alerts": "Alertas",

  "Receipt": "copia del recibo",

  "Brakes": "Frenos",

  "Location": "Ubicacion",

  "Server Error": "Navegador del servidor",

  "OK": "Ok",

  "Info": "Informacion",

  "Success": "Exito",

  "Confirm logout": "Confirmar cierre de sesion",

  "Are you sure you want to log out of this application?": "Esta seguro que desea cerrar la session de esta aplicacion?",

  "Confirm": "Confirmar",

  "Add": "Agregar",

  "Error": "Error",

  "Input Error": "Error de entrada",

  "Please enable location": "Por favor habilite la ubicacion",

  "Please enable all permission": "Por favor habilite todos los permisos",

  "Retry": "Procesar de nuevo",

  "invalidCharacters": "Caracteres no validos identificados y eliminados",

  "Feedback": "La  reaccion",

  "checkInternet": "Estas desconectado, por favor revisa tu internet",

  "Logs": "Registros",

  "New": "Nuevo",

  "Scheduled": "Programar",

  "DVIR Listing": "Listados DVIR",

  "Sleeper": "Cabina durmiente",

  "SLEEPER_BERTH": "EN_DESCANSO",

  "OIL_FIELD_WAITING": "CAMPO_PETROLERO_EN_ESPERA",

  "DRIVE": "Manejar",

  "Time Remaining": "Tiempo restante",

  "Roadside Inspection": "Inspeccion de carretera",

  "HOS": "HOS",

  "Start Break": "Tomar pausa",

  "Complete": "Terminar",

  "breakEndsIn": "Su pausa termina en:",

  "MINUTES": "Minutos",

  "movedToOffDutyStatus": "Se le movera al estado FUERA DE SERVICIO para comensar el descanso. ¿Estas seguro de que quieres comenzar el descanso?",

  "hrs left": "Horas restantes",

  "ELD Connected": "ELD Conectado",

  "ELD Disconnected": "ELD Desconectado",

  "Pending Approval": "Aprobacion pendiente",

  "pendingReq": "Tiene una solicitud pendiente,  le gustaria ver?",

  "Login to your account": "Ingrese a su cuenta",

  "Forgot Your Password?": "¿Se le olvido la contrasena?",

  "Log In": "Ingrese",

  "Email\/Employee ID": "Correo electronico\/Identificacion de empleado",

  "USERNAME": "Nombre de usario",

  "Please enter valid username": "Por favor ingrese un usuario valido",

  "Please enter valid password": "Por favor use una contrasena valida",

  "Login Fail": "Carga fallida",

  "Wrong username or password.": "Nombre de usuario o contrasena incorrecta",

  "Your login is already in use": "Su inicio de sesion ya esta en uso",

  "Log me in": "Iniciar sesion",

  "The company is suspended, please contact your fleet manager.": "La empresa esta suspendida, comuniquese con su gerente de flota",

  "Please enter email address to reset your password": "Ingrese a su correo electronico para restablecer su contrasena",

  "Submit": "Enviar",

  "Please enter a valid email address": "Por favor introduzca una direccion de correo electronico valido",

  "Check your inbox for the link to reset your password.": "Revise su bandeja de entrada para el enlace para restablecer su contrasena",

  "Reset Success": "Restablecer exito",

  "Reset Password Failed": "Restablecer contrasena fallo",

  "Wrong email": "Correo electronico incorrecto",

  "You are required to use ELD": "Se requiere que use ELD",

  "You are exempt from using ELD": "Estas exento de usar ELD",

  "Please provide your cycle details": "Proporcione los detalles de su ciclo",

  "Select": "Seleccione",

  "Personal Conveyance": "Transporte personal",

  "Yard Moves": "Yardas movidas",

  "Non-DOT": "Sin DOT",

  "Distance In": "Distancia dentro",

  "Hardware": "Equipo",

  "Device Name": "Nombre del dispositivo",

  "Scan": "Escanear",

  "Select device": "Seleccione dispositivo",

  "cycleSwitchNotPosiible": "Interruptor de ciclo no es posible sin 24 horas de fuera de servicio",

  "Please read the following information carefully": "Lea atentamente la siguiente informacion",

  "Send agreement by email": "Enviar acuerdo por correo electronico",

  "Disagree": "Desacuerdo",

  "Agree": "Acuerdo",

  "No supported app found": "No se encontro ninguna aplicacion compatible",

  "Terms and Conditions": "Terminos y Condiciones",

  "You are logged in from another device": "Ha iniciado sesion desde otro dispositivo",

  "EXIT TO LOGIN": "Salir para iniciar otra sesion",

  "Signature saved": "Firma guardada",

  "provideSign": "Proporcionar firma antes de guardar",

  "Add your Signature": "Agregar su firma",

  "Vehicle": "Vehiculo",

  "Decline": "Declinacion",

  "Continue without a vehicle": "Continuar sin vehiculo",

  "View Trailer": "Ver trailer",

  "You are working in Non-Vehicle mode\\nUse SEARCH to find a vehicle or contact your fleet manager": "Esta trabajando en modo sin vehiculo\\utilize BUSQUDA para encontrar un vehiculo o comuniquese con el gerent de su flota",

  "Use SEARCH to find a vehicle or contact your fleet manager": "Use la BUSQUEDA para encontrar el vehiculo o comuniquese con el gerente de su flota",

  "Sorry no vehicle found": "No se ha encontrado ningun vehiculo",

  "Change Trailer": "Cambio de trailer",

  "UNIT": "Unidad",

  "Log Details": "Detalles de registro",

  "Unidentified Driver Logs": "Registro de conductores no identificados",

  "ELD Info": "Informacion ELD",

  "Share": "Compartir",

  "Manual": "Manual",

  "Daily Documents": "Documentos diarios",

  "Switch to Mechanic": "Cambiar a mecanico",

  "TIME ZONE OFFSET FROM UTC": "DESPLAZAMIENTO DE ZONA HORARIA DE UTC",

  "CHART": "GRAFICO",

  "I hereby certify that my data entries and my record of duty status for the 24-hour period are true and correct": "Certifico que mis datos de ingresados y mi registro de estado de servicio durante el periodo de 24 horas son verdaderos y correctos",

  "locationValidation": "La ubicacion debe tener al menos 5 caracteres y no debe contener simbolos especiales",

  "Not Ready": "No estoy listo",

  "Remarks should be at least 4 characters": "Commentaries debe tener al menos 4 caracteres",

  "Edit Log Info": "Editar informacion de registro",

  "Save Edits": "Guardar ediciones",

  "Add Trailers": "Agregar trailes",

  "Please separate Trailer Names with a comma": "Separar los nombres de los trailers con una coma",

  "includeTrailerNames": "Incluir \\`,\\` entre los nombres de los trailers. incluir solo los nombres de los trailers",

  "Log Successfully updated": "Registro actualizado con exito",

  "savedTemporarily": "Cambios guardados temporalmente. Las ediciones guardadas se sincronizaran una vez que este en linea.",

  "Notes must have 4-60 characters": "Las notas deben tener de 4-60 caracteres",

  "vehicleMust": "Debe tener un vehiculo seleccionado para acoplar el remolque",

  "vehicleBeforeDrivingStatus": "Por Favor seleccionar un vehiculo antes de cambiar al estado conductor",

  "vehicleBeforeSleeperStatus": "Por Favor seleccionar un vehiculo antes de cambiar al estado dormitorio",

  "Edit Event": "Editar evento",

  "Select Status": "Eeleccionar estatus",

  "OFF": "FDS",

  "ON": "DS",

  "SB": "ED",

  "DR": "MA",

  "OW": "CPE",

  "START": "EMPEZAR",

  "END": "FIN",

  "DURATION": "DURACION",

  "PERSONAL USE": "USO PERSONAL",

  "OILFIELD EXEMPTION": "Exencion de yacimientos petroliferos",

  "AG EXEMPTION": "Exención de AG",

  "Non-DOT Trip": "Viaje sin DOT",

  "Location must have minimum 5 characters and maximum 60 characters": "Ubicacion debe tener minimo 5 caracteres maximo 60  caracteres",

  "Note must have minimum 4 character and maximum 60 characters": "Nota debe tener minimo 4 caracteres maximo 60 caracteres",

  "adjustEdit": "No puede editar el tiempo de conduccion capturado por el ELD.  Ajuste su edicion respectivamente",

  "Send": "Enviar",

  "Enter annotation": "Ingresar anotacion",

  "Add New Event": "Agregar events nuevo",

  "Re-assign": "Reasignar",

  "Warning": "Aviso",

  "logoutTrackingWillStop": "Vas a cerrar la session. Todo seguimiento se detendra",

  "DOT Inspection Guide": "Guia de inspeccion DOT",

  "Send Logs to DOT": "Enviar registros a DOT",

  "View Log History": "Ver historial de registro",

  "View Manual": "Ver manual",

  "viewLastDownloadDailyLogs": "Esta desconectado.  Solo puede ver los ultimos registros diarios descargados",

  "Log History": "Registro historial",

  "SPEED (mph)": "Velocidad (mph)",

  "ODOMETER (Miles)": "Odometro (millas)",

  "ODOMETER (Kilometer)": "Odometro (kilometros)",

  "ENGINE HOURS": "HORAS DE MOTOR",

  "Report Issue": "Reportar problema",

  "Update Firmware": "Actualizar firmware",

  "Connected": "Conectado",

  "Disconnected": "Desconectado",

  "Please connect to the ELD for updating the odometer": "Por favor conectese al ELD para actualizar el odometro",

  "Update": "Actualizar",

  "Please connect to the ELD for updating the Firmware": "Por favor conectese al ELD para actulizar el firmware",

  "NOTATION": "NOTACION",

  "Please enter a notation": "Por faor ingrese una notacion",

  "Send Logs": "Enviar registro",

  "Logs successfully sent": "Registros enviados un exito",

  "Oil Field Waiting": "Campo petrolero esperando",

  "Agricultural Exemption": "Agricultura exenta",

  "Adverse Condition": "Condicion adversa",

  "Your Location (5-60 chars)": "Su ubicacion (5-60 caracs)",

  "Remarks (Max 60 chars)": "Comentarios (max 60 caracs)",

  "Unable to logout while Driving. Please change your status to On Duty or Off Duty or Sleeper.": "Incapaz de cerrar sesion mientras conduce. Por favor cambie su estado a en servicio o fuera de servicio o durmiendo",

  "Unable to change vehicle while Driving or in Sleeper. Please change your status to On Duty or Off Duty.": "No puede cambiar de vehiculo mientras conduce, o en el dormitorio.  Por favor cambie su estado a en servicio o fuera de servicio",

  "This application is running background.": "Esta aplicacion se esta ejecutando en segundo plano",

  "You are working in Non-Vehicle mode": "Esta trabjando en modo sin vehiculo",

  "Connection lost to device": "Conecion perdida con el despositivo",

  "Please check connection to ELD device and double check whether Bluetooth connection is working.": "Por favor verifique la conexion al dispositvo ELD y verifique dos veces que la conexion del diente azul este funcionando",

  "Ignore": "Ignorar",

  "Connect to new Device": "Conectese al despositvo nuevo",

  "Enter current odometer value in miles": "Ingrese al valor actual del odometro en millas",

  "Enter odometer value here": "Ingrese el valor del odometro aqui",

  "Please enter a valid odometer value": "Por favor ingrese un valor valido del odometro",

  "Started processing unidentified logs": "Comenzo a procesar registros no identificados",

  "Unidentified logs processing has been completed": "Se ha completado el procesamiento de registros no identificados",

  "You will have to switch status to Off Duty or On Duty to begin the rest break. Are you sure you want to begin rest break?": "Tendra que cambiar el estado a fuera de servicio o en servicio para comenzar el descanso.  Esta seguro de que desea comensar el descanso?",

  "Go On Duty": "Ir a servicio",

  "Go Off Duty": "Salir de servicio",

  "Vehicle In Motion": "Vehiculo en movimiento",

  "Functionality is limited while the vehicle is in motion": "Funcionalidad es limitada mientras el vehiculo esta en movimiento",

  "Are you sure you want to continue in Personal Conveyance?": "Esta seguro de que quiere continuar en transporte personal?",

  "Stay in PC": "Quedarse en la PC",

  "Delay before auto switch to ON DUTY": "Retraso antes del cambio automatico a en servicio",

  "STAY DRIVING": "Seguir conduciendo",

  "Driver Profile": "Perfil de conductor",

  "Mechanic Profile": "Merfil de mecanico",

  "Mechanic Name": "Nombre de mecanico",

  "Change": "Cambio",

  "No Trailers": "No trailers",

  "No Vehicle": "No vehicle",

  "Please enter your password before returning to the Driver Dashboard": "Por favor ingrese su contrasena antes de regresar al tablero de conducir",

  "Alert": "Alerta",

  "No unidentified logs available": "No hay registros no identificados disponibles",

  "You are on the latest firmware version": "Tiene la ultima version de firmware",

  "Update available": "Actualizacion disponible",

  "A new version of firmware is available. If you proceed to update, please don\\'t leave this page or quit the application until the update completes.": "Hay un nuevo firmware disponible. Si continua con la actualizacion, no abandone esta pagina ni salga de la aplicacion hasta que se complete la actualizacion",

  "Firmware Update": "Actualizacion de firmware",

  "Update in progress": "Actualizacion en progreso",

  "Error while updating firmware": "Error al actualizar el firmware",

  "unidentifiedDriverLogsProcessed": "Se estan procesando registros de controladores no identificados. Intentelo de nuevo mas tarde",

  "The ELD will reboot, so please try connecting to the ELD again.": "La ELD se reiniciara, asi que intente conectarse de nuevo a la ELD",

  "Phone number": "Numero de telefono",

  "Other phone number": "Otro numero de telefono",

  "Website link": "Enlace de pagina web",

  "copied!": "Copiada",

  "New Version Available": "Nueva version disponible",

  "An update is available on Play Store. Please update to new version to continue using the application": "Hay una actualizacion disponible en Play Store.  Por favor actualice a una nueva version para continuar usando la aplicacion",

  "Manage Co-Drivers": "Gestionar copilotos",

  "Remove": "Retirar",

  "Reject": "Rechazar",

  "addCoDriver": "No ha agregado ningun copiloto.  Por favor buscar y agregar copilotos precionando en el boton Agregar",

  "Co-Driver Remove Confirmation": "Copiloto eliminar confirmacion",

  "Are you sure you want to remove Tony as your co-driver?": "Esta seguro que quiere elimanar a Tony como su copiloto?",

  "Tony is requesting you to be his co-driver for Unit 1.": "Tony le pide que sea su copiloto para la unidad 1",

  "Tony is requesting to remove you as his co-driver for Unit 1 Please confirm.": "Tony esta solicitando que lo elimine come su copiloto para la unidad 1, por favor confirme",

  "Add Co-Drivers": "Agregar copilotos",

  "Please search and add Co-Drivers by clicking on the search bar.": "Busque y agregue copilotos presionando en la barra de busqueda",

  "Enter Co-Driver Name": "Por favor ingrese nombre del copiloto",

  "Co-driver request has been sent": "Se ha enviado la solicitud del copiloto",

  "Co-Driver Request Error": "Error de solicitud del copiloto",

  "Request failed": "Solicitud fallida",

  "Co-Driver Request": "Solicitud de copiloto",

  "Today": "Hoy",

  "TOTAL": "TOTAL",

  "Kilometers": "Kilometros",

  "Annotation should be at least 4 characters": "Anotacion debe ser al menos 4 caracteres",

  "Approve Log": "Aprobacion de registro",

  "Reject Log": "Rechazar registro",

  "Select Co-Driver": "Seleccionar copiloto",

  "Successfully assigned to co-driver": "Asignado con exito a copiloto",

  "No Inspections": "Sin inspecciones",

  "Driver Inspection": "Inspeccion de conductor",

  "Sign and Sync All DVIRs": "Firma y sincroniza todos los DVIR",

  "Sync All DVIRs": "Sincroniza todos los DVIR",

  "Synced": "Sincronizada",

  "Signed": "Firma",

  "You are being placed into On Duty Not Driving status": "Se le coloca en el estado En Servicio No Conduciendo",

  "ODOMETER IN MILES": "Odometro en millas",

  "ODOMETER IN KILOMETERS": "Odometro en kilometros",

  "Pre-Trip": "Antes de viaje",

  "Post-Trip": "Despues de viaje",

  "Edit Defect description": "Editar descripcion del defecto",

  "Add remarks": "Agregue comentarios",

  "Odometer value is mandatory": "El valor del odometro es obligatorio",

  "Please enter value for \\\"ODOMETER\\\" field": "Por favor ingrese un valor para el espacio odometro",

  "Done editing inspection?": "Inspeccion de edicion hecha?",

  "incompleteInspection": "No podra continuar con la edicion porque la inspeccion no esta completa y se eliminara",

  "Dismiss inspection": "Despedir la inspeccion",

  "Proceed to": "Proceder a",

  "This feature is not subscribed. Please contact your fleet manager for more details.": "Esta funcion no esta suscrita.  Por favor comuniquese con el adminstrador de su flota para obtener mas detalles",

  "Upgrade Required": "Se requere actualizacion",

  "Please upgrade to use this feature": "Por favor actualizar para usar esta funcion",

  "Upgrade": "Mejorar",

  "Other": "Otro",

  "REMOVE DOCUMENT": "Eliminar documento",

  "Delivery Receipts": "Recibos de entrega",

  "Dispatch Records": "Expedientes de despacho",

  "Bills of Lading": "Guia de carga",

  "Receipts": "Recibos",

  "Weight Tickets": "Boletos de peso",

  "Communication Records": "Registros de comunicacion",

  "Other Documents": "Otros documentos",

  "Daily Eld Other": "Diaria ELD otra",

  "View Document": "Ver documento",

  "Create Document": "Crear documento",

  "CUSTOMER NAME": "Nombre del cliente",

  "JOB NAME": "Nombre del trabajo",

  "BILL OF LADING NUMBER": "Numero de conocimiento de embarque",

  "Upload New Document": "Subir nuevo documento",

  "Successfully Deleted Document": "Documento eliminado un exito",

  "Incorrect or corrupted request": "Petición incorrecta",

  "Your profile was saved": "Su perfil ha sido guardado",

  "Enter job name": "Ingrese el nombre del trabajo",

  "Enter customer name": "Ingrese el nombre del cliente",

  "Enter bill of lading number": "Ingrese el numero del conocimiento de embarque",

  "You may not manually change status to driving, since you have a co-driver assigned": "No puede cambiar manualmente el estado a conducir, ya que tiene un copiloto asignado4",

  "You may not manually change status to driving without connecting to ELD": "No puede cambiar manualmente el estado a conducir sin conectarse a ELD",

  "Currently on": "Prendido",

  "Turn Off": "Apagar",

  "Update Shipping \\ Document Number": "Actualizar el envio \/ el numero de documento",

  "Enter shipping doc number": "Ingrese el numero de documento de envio",

  "Shipping doc number": "Numero de documento de envio",

  "Please enter valid shipping doc number": "Por favor ingrese un numero de documento de envio valido",

  "Please accept or reject the pending log for the day before accepting the UD event": "Por favor accepte o rechaze el registro pendiente del dia anterior a aceptar el evento UD",

  "Please assign or reject UD logs present before logging out": "Por favor asignar o rechazar los registros UD presentes antes de cerrar la sesion",

  "Trailer Type": "Tipo de trailer",

  "Make": "Marca",

  "Plate Number": "Numero de placa",

  "Assigned Vehicle": "Vehiculo asignado",

  "Next Maintenance Date": "Proxima fecha de mantenimiento",

  "Device SN": "Dispositivo SN",

  "Select a trailer type": "Seleccione tipo de trailer",

  "Enter a unit ID": "Ingrese una identificacion de unidad",

  "Enter VIN": "Ingresar numeracion de VIN",

  "Enter year": "Ingresar ano",

  "Enter make": "Ingresar marca",

  "Enter model": "Ingresar modelo",

  "Sign and Save the Report": "Firmar y guardar reporte",

  "Accident": "Accidente",

  "Pull over to safe location; Do not admit fault. Check for injuries": "Detengase en un lugar seguro; No admita culpa. Comprobar si hay lesiones",

  "Please CONFIRM that you have been involved in an accident": "Por favor confirmar que ha estado involucrado en un accidente",

  "Injuries - Call 911": "Heridos - Llame al 911",

  "Alert to server will be skipped due to no internet connectivity": "La alerta al sevidor se omitira debido a que no hay conexion al internet",

  "911 Alert to server will be skipped due to no internet connectivity": "La alerta del 911 al servidor se omitira debido a que no hay conexion a internet",

  "STEP 1\/4 INJURIES": "Parte 1 de 4 - Lesiones",

  "STEP 2\/4 PICTURES": "Parte 2 de 4 - Fotos",

  "STEP 3\/4 WITNESSES": "Parte 3 de 4 - Testigos",

  "STEP 4\/4 POLICE REPORT": "Parte 4 de 4 - Reporte de policia",

  "Dismiss accident": "Accidente eliminado",

  "accidentDataWillBeLost": "Los datos del accidente se perderan y no se enviara nada al sevidor",

  "It is important to identify parties involved and gather their information right away. If there are no witnesses check CONTINUE.\\n\\nIMPORTANT: Get all Witness Statements": "Es importante identificar a las partes involucradas y recopilar su informacion de inmediato.  Si no hay testigos, marque continue.   Importante: Obtenga todas las declaraciones de los testigos",

  "Enter witness details below:": "Ingresar detalles de los testigos",

  "DRIVER LICENSE NUMBER": "NUMERO DE LICENCIA DEL CONDUCTOR",

  "ZIP CODE": "CODIGO POSTAL",

  "tel:911": "Telefono 911",

  "Choose witness type": "Elegir tipo de testigo",

  "REPORT NO": "Numero de reporte",

  "BADGE NO": "Numero de insignia",

  "IMPORTANT: Take photos of all 4 corners of each vehicle and 2 photos of the accident scene.": "IMPORTANTE:  Tome fotos de las 4 esquinas de cada vehiculo y 2 fotos de la escena del accidente",

  "Describe the types of vehicles in the accident, what you saw happen, what time of day is it, was it poor road conditions, who you think is at fault.": "Describa los tipos de vehiculos en el accidente, lo que vio que sucedio, a que hora del dia, las malas condiciones de la carretera, quien cree que tiene la culpa",

  "Done recording": "Grabacion terminada",

  "Cancel recording": "Grabacion cancelada",

  "ACCIDENT SCENE": "Escena  de accidente",

  "TRUCK": "Troca",

  "TRAILER": "Trailer",

  "Example: Guard rail, signs, light pole, etc. (add # of photos as needed)": "Ejemplo:  Barandilla, letreros, poste de luz etc. (agregue fotos segun sea necesario)",

  "PHOTO": "FOTOS",

  "Witness name is mandatory": "Nombre de testigos es mandatorio",

  "Please enter Full Name": "Ingrese nombre completo",

  "LogBook is not required.\\nYou\\'re operating under Local Radius duty cycle.": "El libro de rgistro no es necesario.  Esta operando bajo el ciclo de trabajo del radio local",

  "Order Id": "Identificacion del pedido",

  "Some error occurred. You can only view downloaded work orders.": "Ocurrio algun error.  Solo puede ver las ordenes de trabajo descargadas",

  "ORDER #": "Numero del pedido",

  "CREATED BY": "Creado por",

  "DEFECTS LIST": "LISTA DE DEFECTOS",

  "DUE DATE": "FECHA DE VENCIMIENTO",

  "CONCERN": "PREOCUPACION",

  "Completed": "Completo",

  "DEFECT DETAILS": "DETALLES DEL DEFECTO",

  "COMMENTS BY MECHANIC": "COMENTARIOS DE MECANICO",

  "Unable to retrieve service request detail. Service request ID was114": "No se pudo recuperar el detalle de la solicitud de servicio.  La identificacion de la solicitud de servicio era 114",

  "New Service Request": "NUEVA SOLICITUD DE SERVICIO",

  "Scheduled SR": "SR programado",

  "Satisfactory DVIRs": "Satisfactorio DVIR's",

  "DVIRs with Defects": "DVIR'S con defectos",

  "All DVIRs": "Todos los DVIR'S",

  "Some error occurred. You can only view downloaded inspections.": "Ocurrio algun error.  Solo puede ver las inspecciones descargadas",

  "No DVIRs": "No DVIR'S",

  "Sorry no vehicle assigned": "Vehiculo no esta asignado",

  "Are you sure you want to remove the vehicle?": "Esta seguro de que quieres eliminar este vehiculo?",

  "Please enter all required information.": "Por favor ingresar toda la informacion requerida",

  "ScheduledDateBeforeReportedDate": "La fecha programada no puede ser anterior a la fecha informada",

  "DueDateGreaterthanScheduledOrReportedDate": "La fecha de vencimiento no puede ser mayor que la fecha programada o informada",

  "Clutch Connectivity Log": "Registro de conectivdad del embrague",

  "In order to continue using Clutch ELD on this device you need to re-login.": "Para continuar usando Clutch ELD en esta unidad, debe volver a iniciar sesion",

  "The future of Fleet Management! We bring the power of technology to your fleet through the most advanced transportation software on the market today. \\n\\nVisit us at www.clutcheld.com": "El futuro del administrador de flotas! Llevamos el poder de la tecnologia a su flota a traves del software de transporte mas avanzado del mercado actual. Visitenos en www.clutcheld.com",

  "Tap here to proceed to": "Presione aqui para proceder",

  "24 Hour Cycle Reset": "Reinicio del ciclo de 24 horas",

  "Oil Field Exception": "Excepcion de campo petrolifero",

  "NONE": "Ninguno",

  "Heavy Duty": "Pesado servicio",

  "Light Duty": "Trabajo ligero",

  "Log out": "Cerrar sesion",

  "Are you sure you want to logout of this application?": "Esta seguro de que quiere cerrar la sesion de esta aplicacion?",

  "Continue": "Continue",

  "Sorry no trailer assigned to this vehicle": "No hay trailer asignado a este vehiculo",

  "Are you sure you want to delete the trailer?": "Esta seguro de que quiere eliminar el trailer?",

  "Maximum trailer assigned to this vehicle, please remove any trailer to add new trailer": "Remoque maximo asignado a este vehiculo, retire cualquier remolque para agregar un remolque nuevo",

  "This trailer is already assigned to a vehicle. Do you want to continue?": "Tste trailer ya esta asignado a este vehiculo.  Quiere contiuar?",

  "APPROVE": "APROBADO",

  "No notifications": "No notificaciones",

  "UnidentifiedDriverOnELD": "Hay un conductor no identificado en el ELD",

  "Prime8 ELD has identified a data diagnostic event. The Prime8 ELD Diagnostic Event is MRDD.": "Prime8 ELD ha identificado un evento de diagnostico de datos.  El evento de diagonstico de Prime8 es MRDD",

  "Please complete your pre-trip DVIR before starting driving.": "Por favor complete su DVIR previo al viaje antes de comenzar a conducir",

  "Please complete your post-trip DVIR at the end of the day.": "Por favor complete su DVIR previo al viaje al final del dia",

  "you did not your DVIR pre-trip before you started driving": "No completo su DVIR previo al viaje antes de comenzar a conducir",

  "If you have completed your day, please complete your post-trip DVIR.": "Si ha completado su dia, completado su DVIR posterior al viaje",

  "Prime8 ELD has reported a malfunction. Contact your manager immediately. Please stop using the Prime8 ELD RODS and switch to paper logs until the ELD malfunction has been corrected.": "Prime8 ELD ha informado de un mal funcionamiento.  Comuniquese con su gerente de inmediato.  Por favor deje de usar el Prime8 ELD RODS y cambie a los registros de papel hasta que se haya corregido el mal funcionamiento del ELD",

  "The Prime8 ELD Malfunction that has occurred is PCM.": "El mal funcionamiento de Prime8 que ha ocurrido es PCM.",

  "You violated 11hr Driving Limit.": "Violo el limite de conduccion de 11 horas",

  "You violated 14hr Driving Window Rule.": "Violo la regla de la ventana de conduccion de 14 horas",

  "You violated Rest Breaks Rule.": "Violo la regla de los descansos",

  "Your duty cycle has expired. You may be in violation.": "Su ciclo de trabajo ha expirado.  Puede estar en violacion",

  "You violated 16 Hour Elapsed Time Rule.": "Violo la regla de tiempo transcurrido de 16 horas",

  "You violated off-duty limit for today.": "Violo el limite de fuera de servicio por hoy",

  "You violated off-duty limit for last shift day.": "Violo el limite de fuera de servicio para el ultimo turno de hoy",

  "You are operating outside of compliance. Please sign your logbook.": "Esta operando fuera del cumplimiento.  Firmar su libro de registro",

  "Certification is required for drivers updated log. Go to Logs page for pending action. Annotation provided in info tab.": "Se requiere certificacion para el registro actualizado del conductor.  Vaya a la pagina de registros para ver las acciones pendientes.  Anotacion proporcionada en la pestana de informacion",

  "Please pair your device with ELD.": "Por favor emparejar su dispositvo con ELD",

  "You are not connected to ELD.": "No esta connectado al ELD",

  "Your 14hr Driving Window is approaching. Please stop driving in 5 min.": "Se acerca la ventana de conduccion de 14 horas.  Deje de conducir en 5 minutos",

  "Your 11hr Driving Limit is approaching. Please stop driving in 5 min.": "Se acerca el limite de conduccion de 11horas.  Deje de conducir en 5 minutos",

  "Please take 30 minute break from Driving within 5 min.": "Por favor tome un descanso de 30 minutos de la conduccion en 5 minutos",

  "You are out of driving hours. Please stop driving.": "Esta fuera de las horas de conduccion.  Deje de conducir",

  "Delay in receiving data from ELD.": "retraso en recibir datos de ELD",

  "Your Drive Time Expires": "Su tiempo de conducir se ha vencido",

  "Your Break Time Expires": "Su tiempo de descanso se ha vencido",

  "Flatbed": "Remolque de plataforma",

  "Dry Van": "Camioneta de caja seca",

  "Reefer": "Remolque refrigerado",

  "Tanker": "Remolque cisterna",

  "DRIVERS OF": "CONDUCTORES DE",

  "Dump": "Remolque volquete",

  "Vacuum": "Remolque de vacío",

  "Pneumatic": "Neumático",

  "Service Center": "Centro de servicio",

  "Search Service Center": "Buscar centro de servicio",

  "Sorry no service center found": "Lo sentimos, no se encontró ningún centro de servicio",

  "Use SEARCH to find a service center or contact your fleet manager": "Use la busqueda para encontrar un centro de servicio o comuniquese con el gerente de su flota",

  "You are offline. Please check your internet connection. You are only be able to change service center only when you are online.": "Esta desconectado.  Comprueba su conexion al internet.  Solo puede cambiar de centro de servio cuando esta en linea",

  "Fuel Amount": "Cantidad de combustible",

  "Enter amount of gallons": "Ingrese cantidad de galones",

  "Enter fuel cost in $": "Ingrese el costo de combustible en dolares",

  "You need to enter all fields values and attach receipt.": "Debe ingresar todos los espacios, valores, y adjuntar recibos",

  "Upload completed succesfully": "Carga completada con exito",

  "Changes saved temporarily. The submitted receipts will be synced once you are online.": "Cambios guardados temporalmente.  Los recibos enviados se sincronizaran una vez que este en linea",

  "Enter part name": "Ingrese nombre de la pieza",

  "Parts Inventory": "Inventario de piezas",

  "No parts added. Please search and add the part.": "No hay partes agregadas.  Por favor busque y agregue la pieza",

  "No related parts found. Try searching for different keywords.": "No se encontraron partes relacionadas.  Intente buscar diferentes palabras clave",

  "Price": "Precio",

  "Part Name": "Nombre de la pieza",

  "Inventory Count:": "Cuenta de inventario",

  "Part Already Selected!": "Pieza seleccionada",

  "This part is already present in the parts list": "Esta pieza ya esta presente en la lista de partes",

  "Parts have been updated": "Las partes han sido actualizadas",

  "Delete": "Eliminar",

  "No Work Orders": "No hay ordenes de trabajo",

  "Unable to retrieve service request detail. Work order ID was 1100": "No se puede recuperar el detalle de la solicitud de servicio.  Identificacion de la orden de trabajo era 1100",

  "New WO": "Nuevo WO",

  "Scheduled WO": "Horario WO",

  "WO History": "Historial de WO",

  "WO #": "Numero de WO",

  "Review WO": "Revisar el WO",

  "Canada 70 hour \/ 7 day South": "Canada 70 horas \/ 7 dias Sur",

  "Canada 120 hour \/ 14 day South": "Canada 120 horas \/ 14 dias Sur",

  "Canada 80 hour \/ 7 day North": "Canada 80 horas \/ 7dias Norte",

  "Canada 120 hour \/ 14 day North": "Canada 120 horas \/ 14 dias Norte",

  "Vehicle Compliant With 396 Regulations?": "El vehiculo cumple con las regulaciones 396?",

  "NO": "No",

  "YES": "Si",

  "NO": "NO",

  "Dailylog": "Registro diario",

  "DRIVER\\'S DAILY LOG": "CONDUCTORS REGISTRO DIARIO",

  "Please read and sign all your policies and procedures": "Por favor lea y firme todas sus polizas y procedimientos",

  "You have not signed policies and procedures": "No ha firmado las polizas o procedimientos",

  "There was an issue signing policy. Try again later.": "Hubo un problema con la firma de la poliza.  Intente mas tarde",

  "Policy ID is invalid": "La identificacion de la poliza no es valida",

  "Policies": "Polizas",

  "Sign": "Firma",

  "Mechanic feature is not subscribed. Please contact your fleet manager for more details.": "La fiuncion mecanica no esta suscrita.  Comuniquese con el gerente de su flota",

  "DEFECTS DETAILS": "DETALLES DE DEFECTOS",

  "COMMENTS BY DRIVER": "COMENTARIOS POR EL CONDUCTOR",

  "VIEW PHOTOS": "VER FOTOS",

  "Missing parts check": "Piezas faltanted comprobadas",

  "Please perform the check on all parts in the current section and mark as Ok\/Defect": "Por favor realice la verificacion en todas las partes en la seccion actual y marque como ok\/defecto",

  "OUT OF SERVICE": "FUERA DE SERVICIO",

  "You are allowed only to switch to Adverse Driving Mode since you have a co-driver assigned. Do you need to enable ADC mode?": "Solo se le permite cambiar al modo de conduccion adversa ya que tiene un copiloto asignado.  Necesita habilitar el modo ADC?",

  "You are allowed only to switch to Adverse Driving Mode without connecting to ELD. Do you need to enable ADC mode?": "Solo se le permite cambiar al modo de conduccion adversa sin conectarse a ELD.  Necesita habilitar el modo ADC?",

  "You cannot begin inspection in non-vehicle mode. Please choose a vehicle to continue": "No puede comenzar la inspeccion en modo sin vehiculo.  Elige un vehiculo para continuar",

  "Fuel Info": "Informacion de combustible",

  "Manage Parts": "Administrar partes",

  "Are you sure you want to remove the part?": "Esta seguro de que quiere eliminar la pieza",

  "You have service requests awaiting review. Go to service requests review page for pending action.": "Tiene solicitudes de servicio pendientes de revision.  Vaya a la pagina de revision de solicitudes de servicio para ver las acciones pendientes",

  "Accident data will be lost and nothing will be sent to server": "Los datos del accidente se perderan y no se enviara nada al sevidor",

  "Are you sure you want to remove the receipt?": "Esta seguro de que quiere eliminar el recibo?",

  "No Service Request": "No hay solicitud de servicio",

  "Please contact the sales team to continue using the app": "Comuniquese con el equipo de ventas para seguir usando la aplicacion",

  "Assess vehicle conditions:": "Evaluar las condiciones del vehiculo",

  "Assess trailer conditions:": "Evaluar las condiciones del trailer",

  "UNSATISFACTORY": "INSATISFACTORIA",

  "SATISFACTORY": "SATISFACTORIO",

  "VEHICLE NAME": "NOMBRE DEL VEHICULO",

  "REPORTED": "REPORTADO",

  "SCHEDULE": "PROGRAMAR",

  "TOTAL COST": "COSTO TOTAL",

  "LABOUR COST": "COSTO LABORAL",

  "PARTS COST": "COSTO DE PIEZAS",

  "PART": "PARTE",

  "VIEW REPORT": "VER REPORTE",

  "CORRECTION": "CORRECCION",

  "CAUSE": "CAUSA",

  "Completed WO": "WO Completo",

  "WO #": "Numero de orden de trabajo   OR  Numero de WO",

  "NEW SR": "Nuevo SR",

  "COMPLETED SR": "SR Completo",

  "SR #": "Numero de SR",

  "Fuel Tracker": "Rastreador de combustible",

  "ODOMETER": "ODOMETRO",

  "TOTAL COST": "COSTO TOTAL",

  "RECEIPT": "RECIBO",

  "Enter amount in gallons": "Ingrese cantidad de galones",

  "Enter odometer reading": "Ingrese la lectura del odometro",

  "Enter total fuel cost in $": "Ingrese el costo total del combustible",

  "Your fuel info have empty fields or no receipt": "Su informacion de combustible tiene espacios vacios o no hay recibos",

  "Location cannot be empty": "La hubicacion no puede estar vacia",

  "The Pdf link is not available please contact the admin": "El enlace PDF no esta disponible comuniquese con la administracion",

  "Reported defect does not have any images attached": "El defecto informado no tiene imagenes adjuntas",

  "Please approve\/reject all the defect items": "Aprobar\/Rechazar todos los articulos defectuosos",

  "Please fix all the defect items before completing the work order": "Arreglar todos los articulos defectuosos antes de completar la orden de trabajo",

  "VIEW PHOTOS": "VER FOTOS",

  "There are no images attached for this work order": "No hay imagenes adjuntas a esta orden de trabajo",

  "View Policies": "Ver polizas",

  "No parts found": "No se encontraron piezas",

  "Sorry you have already selected this part": "ya ha seleccionado esta parte",

  "Already Added": "Ya has agregado",

  "Please enter notes": "Por favor ingrese notas",

  "You should enter start and due dates": "Ddbe ingresar las fechas de inicio y vencimiento",

  "Start date must be earlier than due date": "La fecha de inicio debe ser anterior a la fecha de vencimiento",

  "Add service center": "Agregar centro de servicio",

  "Enter Service Center Name": "Nombre del centro de servicio",

  "No Service Center found": "No se encontro ningun centro de servicio",

  "Please choose one the service center before submiting": "Elija un centro de servicio antes de enviar",

  "User was de-activated successfully": "El usuario se desactivo con exito",

  "User was activated successfully": "El usuario se activo con exito",

  "A verification email has been sent to your email. Please click on the link to enable email notifications": "Se ha enviado un correo electronico de verificacion a su correo electronico.  Presione en el enlace para habilitar las notificaciones por correo electronico",

  "You have disabled email notifications": "Ha desabilitado notificaciones de su email",

  "Successfully enabled the notification": "Habilitado con exito las notificaciones",

  "Invalid file!": "Expediente invalido",

  "Default Fleet Manager cannot be deleted or de-activated": "El administrador de flota pre-determinado no se puede eliminar ni desactivar",

  "Invalid token": "Simbolo no valido",

  "Token expired or invalid JWT token": "Simbolico vencido o simbolico JWT no valido",

  "unexpectedErrorReq": "Ocurrio un error inesperado al procesar la solicitud.  Intentalo de nuevo mas tarde",

  "User's email can't be empty": "El correo electronico del usuario no puede estar vacio",

  "The e-mail is not registered": "El correo electronico no esta registrado",

  "You are not authorized to do this request": "No esta autorizado a realizar esta solicitud",

  "User was deleted successfully": "La usuario fue eliminada exitosamente",

  "Failed to activate user": "No se pudo activar el usuario",

  "User not found": "Usuario no encontrado",

  "Time zone not available": "Zona horaria no disponible",

  "Please enter no more than 50 characters": "Ingrese no mas de 50 caracteres",

  "user has region already assigned to him": "El usuario ya tiene una region asignada",

  "Subscription not available": "Suscripcion no disponible",

  "Please agree to the Terms Of Use": "Por favor aceptar el uso de terminos",

  "Company with this email already exists": "La empresa con este correo electronico ya existe",

  "Flex companies cannot have more than 3 vehicles": "Las empresas flexibles no pueden tener mas de 3 vehiculos",

  "Invalid producer code": "Codigo de productor no invalido",

  "Company with the given dot number already exists": "La empresa con con el numero DOT dado ya existe",

  "Please enter a valid password": "Por favor ingresar una contrasena valida",

  "Timezone not found. Please enter a valid timezone": "Zona horaria no encontrada.  Por favor ingrese una zona horaria valida",

  "Invalid payment details": "Detalles de pago no validos",

  "Invalid captcha": "captcha (un programa o systema) invalida",

  "Card Cannot be Registered\/Charged in BrainTree": "La tarjeta no se puede registrar\/cargar en BrainTree",

  "Flex registration is not enabled": "El registro flexible no esta habilitado",

  "Payment failed": "Pago fallido",

  "BrainTree Exception occured during Payment": "se produjo una excepcion de BrainTree durante el pago",

  "Company not found": "Empresa no encontrada",

  "unexpectedError": "Ocurrio un error inesperado al procesar la solicitud de registro.  Intentalo de nuevo mas tarde",

  "Your feedback has been sent successfully": "Sus comentarios se han enviado con exito",

  "There are active service requests existing for this vehicle": "Existen solictudes de servicio activas para este vehiculo",

  "Please delete users under this department\"": "Eliminar usuarios de este departamento",

  "Please delete location under this department": "Eliminar ubicacion en este departamento",

  "Department already exists": "El departamento ya existe",

  "Cannot reset filter set by fleet manager": "No se puede restablecer el filtro establecido por el administrador de la flota",

  "Location already exists": "Ubicacion ya existe",

  "Cannot reset location set by fleet manager": "No se puede restablecer la ubicacion establecida por el administrador de la flota",

  "Region already exists": "Region ya existe",

  "Please remove users under this region": "Eliminar usuarios bajo esta region",

  "Please delete terminal under this region": "Eliminar la terminal bajo esta region",

  "Cannot reset region set by fleet manager": "No se puede restablecer la region establecida por el administrador de la flota",

  "Terminal already exists": "La terminal ya existe",

  "Please remove users under this terminal": "Eliminar usuarios bajo esta terminal",

  "Please delete departments under this terminal": "Eliminar departamentos bajo esta terminal",

  "Cannot reset terminal set by fleet manager": "No se puede restablecer el terminal configurado por el administrador de la flota",

  "Please delete users under this location": "Eliminar usuarios bajo esta ubicacion",

  "Cannot reset subdepartment set by fleet manager": "No se puede restablecer el subdepartamento establecido por el administrador de la flota",

  "passwordValidation": "La contrasena debe tener no menos de 6 caracteristicas y no mas de 15. debe tener una letra mayuscula, una minuscula, un digito, y un simbolo",

  "reprtBeingPrepared": "Su reporte se está preparando y será enviado a su correo electrónico",

  "linkToDownloadInspections": "Su descarga se está preparando. Recibirá un correo electrónico con un enlace para descargar las inspecciones",

  "Account deactivated": "Cuenta desactivada",

  "subscriptionCancelled": "Su suscripcion se ha cancelado.  Registre la empresa de nuevo e intente iniciar sesion",

  "Invalid username\/password": "Usuario y contrasena no es valido",

  "Some error occurred": "Ocurrio un error",

  "User userName not found": "Usuario no encontrado",

  "permission denied": "Permiso denegado",

  "The user doesn't exist": "El usuario no existe",

  "Password does not match": "La contraseña no coincide",

  "Upgrade Subscription": "Suscripcion de actualizacion",

  "Rejected Successfully": "Rechazo fue un exito",

  "Accepted Successfully": "Acceptado fue un exito",

  "Developer Request Accepted": "Solicitud de desarrollador acceptada",

  "Exception occurred while exporting results": "Se produjo una excepcion al explorar los resultados",

  "Invalid or corrupted token": "Simbolo invalido o danado",

  "incorrectCredentials": "Correo o contrasena incorrectos.  Vuelva a intentarlo con las credenciales correctas",

  "recoveryLink": "El enlace de recuperacion fue enviado por correo electronico",

  "Company does not exist": "Empresa no existe",

  "Please add the neccessary details and update your credit card details.": "Agrege los detalles necesarios y actualice los detalles de su tarjeta de credito",

  "You are not able to change Company Data information": "No puede cambiar la informacion de datos de la empresa",

  "In Update card : General Exception Caught": "Al actualizar su tarjeta:  se detecto una excepcion general",

  "Not allowed to access other company daily logs": "No se permite acceder los registros diarios de otras empresas",

  "Not allowed to access other drivers daily logs": "No se permite acceder los registros diarios de otros conductores",

  "New version of real time log is now available for the user.": "La nueva version del registro en tiempo real, ahora esta disponible para el usuario",

  "Update card details": "Actualizar los detalles de la tarjeta",

  "Document with the same name was already uploaded for this user!": "Un documento con el mismo nombre ya fue cargado por este usuario",

  "Invalid format!": "Formato invalido",

  "Deleted!": "Eliminado",

  "Please enter a Valid VIN conforming to the VIN standard": "Introduzca VIN valido conforme al VIN al nivel",

  "Duplicate VIN exist in truck details": "Existe un VIN duplicado en los detalles del camion",

  "No such User": "No hay tal usuario",

  "No Vehicle Found": "Ningun vehiculo encontrado",

  "Vehicle with vin Vin1 already exists": "Vehiculo con VIN 1 ya existe",

  "VINnumberValidation": "El numero de VIN debe tener 17 caracteres.  Solo numeros y letras.  I, O, y Q no estan permitidos",

  "part1 (s) are not available in inventory": "Las partes 1 no estan disponibles en el inventario",

  "email already exists in the database": "El correo electronico ya existe en la base de datos",

  "valueBwtween1to10Length": "Ingrese un valor entre 1 y 10 caracteres de longitud",

  "Company Registration Failed:": "Registro de empresa fallido",

  "Company with same dot number dotnumber1 already exists": "Empresa con el mismo numero de DOT.  Eel numero DOT 1 ya existe",

  "Please enter only numbers and maximum length as 9": "Ingrese solo numeros y debe ser un maximo de 9 numeros",

  "onlyNumbers": "Usar solo numeros y debe ser 12 digitos",

  "Please enter minimum 4 characters": "Ingrese minimo 4 caracteres",

  "Please enter only numbers": "Ingrese solo numeros y debe ser un maximo de 9 numeros",

  "Please enter email address in valid format": "Ingrese la direccion de correo electronico en un formato valido",

  "User with email email1 already exists": "Usuario con correo electronico.  Correo electronico 1 ya existe",

  "Please use only numbers and - and. Length must be 12 digits": "Usar solo numeros y debe ser 12 digitos",

  "Please enter value between 2 and 30 characters": "Ingrese un valor entre 2 y 30 caracteres",

  "Company not exist": "Empresa no existe",

  "User not exist": "Usuario no existe",

  "Company Id not exist": "Identificacion de empresa no existe",

  "Credit card number should contain only numbers": "Numero de tarjeta debera tener solo numeros",

  "Please enter valid credit card number": "Ingrese tarjeta de credito con un numero valido",

  "Please enter valid cvv": "Ingrese un CVV valido",

  "Please enter expiry date in valid format [MM\/YY]": "Ingrese fecha de vencimiento en un formato valido [MM\/YY]",

  "Shipping option must be either Standard or Express": "La opcion de envio debe ser estandar o expres",

  "Subscription plan must be either Monthly or Yearly": "El plan de suscripcion debe ser mensual o annual",

  "Permission Denied : Report not enabled for user": "Permiso denegado:  Informe no habilitado para el usuario",

  "Date format not correct": "El formato de fecha no esta correcto",

  "Exception occurred while exporting dailyHosViolationReport": "Se produjo una excepcion al exportar el INFORME DE VIOLACION DE HOS diario",

  "Exception occurred while exporting dailyUnsignedLogReport": "Se produjo una excepcion al exportar el INFORME DE REGISTRO NO FIRMADO diario",

  "Exception occurred while exporting dailyFailedInspectionReport": "Se produjo una excepcion al exportar el INFORME DE INSPECION FALLIDO diario",

  "Exception occurred while exporting dailyUnidentifiedDrivingReport": "Se produjo una excepcion al exportar el INFORME DO CONDUCION NO IDENTIFICADO DIARIO",

  "Some error occurred while cancelling the subscription. Please try after some time": "Ocurrio algun error al cancelar la suscripcion.  Intentelo de nuevo mas tarde",

  "Trucks number can't be less than count of active trucks": "El numero de camiones no puede ser menor que el recuento de camiones activos",

  "Card Exception occured. Please retry with another card or try again later": "Ocurrio una excepcion de tarjeta.  Vuelva a intentarlo con otra tarjeta o intentelo mas tarde",

  "name can not be empty": "Nl nombre no puede estar vacio",

  "type can not be null": "El tipo no puede ser nulo",

  "year can not be null": "Ano no puede ser nulo",

  "make can not be empty": "Marca no puede estar vacio",

  "model can not be empty": "Modelo no puede estar vacio",

  "nextMaintenance can not be empty": "La siguiente mantenimiento no puede estar vacio",

  "Partial content": "Contenido parcial",

  "USDOT Number already exists": "El numero de USDOT ya existe",

  "FMOrAdminCannotBeDriver": "El gerente o administrador de la flota no puede ser conductor",

  "cantModifyFMroles": "No puede modificar la parte de administrador de flota y administrador de flota (pre-determinado)",

  "It's not possible to set the role \\\"Fleet Manager (Default)\\\" for inactive user": "Mo es posible establecer la parte \\\"Administrador de Flotapre-determinado}\\\" para el usuario inactivo",

  "Manager (Default)" : "Gerente (defecto)",

  "linkToDownloadLogs" : "Su descarga se está preparando. Recibirá un correo electrónico con un enlace para descargar las registros",

  "License State is Mandatory for Drivers": "Licencia del Estado es obligatorio para los conductores",

  "You can't modify Fleet Manager (Default) role to Fleet Manager, Driver or Admin or Mechanic roles": "No puede modificar la parte de administrador de flota (pre-determinado) a las partes de administrador de flota, conductoro administrador o mecanica",

  "Please enter Value between 4 and 60 characters": "Ingrese un valor entre 4 y 60 caracteres",

  "User with Employee ID user1 already exists": "Usuario con Identificacion.  El usuario 1ya existe",

  "License Number license1 already exists": "Numero de licencia.  Licencia 1 ya existe",

  "Please enter Value between 1 and 20 characters": "Ingresar un valor entre 1 y 20 caracteres",

  "Please provide Hire Date in valid format(MM\/DD\/YYYY)": "Proporcione la fecha de contratacion en un formato valido (MM\/DD\/YY)",

  "Please add some valid data": "Agregue algunos datos validos",

  "Active": "Activo",

  "Inactive": "Inactivo",

  "Only three trailers are allowed per Vehicle": "Solo se permiten 3 remolques por vehiculo",

  "subscriptionError": "Ocurrio algun error al actualizar la suscripcion.  Intentelo de nuevo mas tarde",

  "No Drivers Found for this vehicle": "No se encuentran conductores para este vehiculo",

  "driver does not sign his logbook": "El conductor no firma su diario",

  "driver does not complete a DVIR": "El conductor no completa el DVIR",

  "Driver is driving a vehicle with a safety defect": "El conductor esta coonduciendo un vehiculo con un defecto de seguridad",

  "Driver goes over his\/her driving hours": "El\/La conductor\/a repasa sus horas de conduccion",

  "Driver goes over his\/her duty hours": "El\/La conductor\/a repasa sus horas de servicio",

  "Driver goes over his\/her cycle hours": "El conductor repasa sus horas de su ciclo de conduccion",

  "Driver has not taken a break or break was too short": "El conductor no ha tomado un descanso o el descanso fue demasiado corto",

  "You should enter scheduled and due date.": "Debe ingresar las fechas programadas y de vencimiento",

  "Scheduled date must be earlier than due date.": "La fecha programada debe ser anterior a la fecha de vencimiento",

  "Dates can't be before reported date.": "Las fecha no deben ser antes de las fechas reportadas",

  "Access Credentials -": "Credenciales de acceso",

  "Registration Confirmation - GorillaSafety.com": "Confirmacion de Registro - GorillaSafety.com",

  "Hardware Ordered- GorillaSafety.com": "Equipo Pedido - GorillaSafety.com",

  "Malfunction Occured -": "Se produjo un mal funcionamiento",

  "Password Reset -": "Restablecimiento de contrasena",

  "User1 has not signed his logbook": "Usuario 1 no ha firmado su libro de registro",

  "The DRIVING Window is expired for User1": "La ventana de conduccion ha expirado para el usuario 1",

  "The DRIVING Window is about to expire for User1": "La ventana de conduccion esta a punto de expirar para el usuario 1",

  "The ON_DUTY Window is expired for User2": "La ventana de servicio ha expirado para el usuario2",

  "The ON_DUTY Window is about to expire for User2": "La ventana de servicio esta a punto de expirar para el usuario 2",

  "The Duty Cycle limit is expired for User3": "El limite del ciclo de trabajo ha caducado para el usuario 3",

  "The Duty Cycle limit is about to expire for User3": "El limite del ciclo de trabajo esta a punto de expirar para el usuario 3",

  "User1 has been involved in an accident at Texas": "Usuario 1 se ha involucrado en un accidente en Texas",

  "User1 has been involved in an accident at Texas and called 911 indicating injuries are present": "Usuario 1 se ha involucrado en un accidente en Texas y llamo al 911 indicando que hay leciones presente",

  "User1 has not completed DVIR before driving": "Usuario 1 no ha completado DVIR antes de conducir",

  "User1 has not completed DVIR for yesterday after driving": "Usuario 1 no ha completado DVIR para el dia de ayer antes de conducir",

  "User1 has not completed DVIR after driving": "Usuario 1 no ha completado DVIR despues de conducir",

  "User2 drives wrong vehicle": "Usuario 2 conduce vehiculo equivocado",

  "Eld not paired": "ELD no emparejada",

  "Eld not connected": "ELD no esta conectado",

  "Positioning compliance malfunction occurred": "Se projujo un mal funcionmiento de la condormidad de posicionamiento",

  "Data recording compliance malfunction occurred": "Ocurrio un mal funcionamiento del cumplimiento de la grabacion de datos",

  "Power compliance malfunction occured": "Ocurrio un mal funcionamiento de cumplimiento de energia",

  "Engine synchronization compliance malfunction occurred": "Ocurrio un mal funcionamiento del cumplimiento de la sincronizacion del motor",

  "Data transfer compliance malfunction occurred": "Ocurrio una falla en el cumplimiento de la transferencia de datos",

  "DVIR DEFECT": "DVIR DEFECTO",

  "Unit No.Unit1 has been repaired": "La unidad numero 1 ha sido reparada",

  "DVIR NOT SIGNED": "DVIR NO HAY FIRMA",

  "User3 MVR will expire in 30 days": "Usuario 3 MVR se expira en 30 dias",

  "User4 MVR will expire in 14 days": "Usuario 4 MVR se expira en 14 dias",

  "User5 MVR will expire in 5 days": "Usuario 5 MVR se expira en 5 dias",

  "User6 MVR expired": "Usuario 6 se ha vencido",

  "User7 Medical Card will expire in 45 days": "Tarjeta de medico del usuario 7 se expira en 45 dias",

  "User1 Medical Card will expire in 30 days": "Tarjeta de medico del usuario 1 se expira en 30 dias",

  "User1 Medical Card will expire in 15 days": "Tarjeta de medico del usuario 1 se expira en 15 dias",

  "User1 Medical Card expired": "Tarjeta de medico del usuario 1 se ha vencido",

  "User1 License will expire in 60 days": "La licencia del usuario 1 se expira en 60 dias",

  "User1 License will expire in 30 days": "La licencia del usuario 1 se expira en 30 dias",

  "User1 License will expire in 15 days": "La licencia del usuario 1 se expira en 15 dias",

  "User1 License will expire in 7 days": "La licencia del usuario 1 se expira en 7 dias",

  "User1 License expired": "La licencia del usuario 1 se ha vencido",

  "REPAIR OVERDUE": "REPARACION VENCIDA",

  "User1 has declined a vehicle": "Usuario 1 ha rechazado un vehiculo",

  "User1 is driving Unit No.Unit1 with a safety Defect": "Usuario 1 esta conduciendo un vehiculo con un defecto de seguridad",

  "User1 has never logged in": "Usuario 1 nunca ha iniciado sesion",

  "Vehicle1 is missing driver\/mechanic": "El vehiculo 1 le falta conductor\/mecanico",

  "Safety defect repair overdue for Unit No.Unit1": "Reparacion de defectos de seguridad vencida para numero de unidad, unidad 1",

  "User1 has Pending daily log for May 1": "Usuario 1 tiene registro diario pendiente para el 1de Mayo",

  "User1 has requested to access fleets": "El usuario 1 ha solicitado acceder a las flotas",

  "User1 exceeds the available time to drive": "El usuario 1 supera el tiempo disponible para conducir",

  "VIN of the vehicle does not match with the VIN pulled from the VNA for Vehicle1": "VIN del vehiculo no coincide con el VIN extraido del VNA para el vehiculo 1",

  "User1 has accumulated unidentified driving time on Vehicle1": "El usuario 1 ha acumulado tiempo de conduccion no identificado en el vehiculo 1",

  "Please enter value between 4 and 120 character length": "Ingrese un valor entre 4 y 120 caracteres",

  "Please enter valid dotNumber of length between 1 and 9": "Ingrese un numero DOT valido entre 1 y 9",

  "Company name cannot be empty": "Nombre de empresa no debe estar vacio",

  "Dot Number cannot be empty": "El numero de DOT no debe estar vacio",

  "Minimum contract length should be 1 year": "El contrato debe ser minimo 1ano",

  "Maximum contract length should be 3 years": "El contrato debe ser maximo 3 anos",

  "Address cannot be empty": "El domicilio no debe estar vacio",

  "State cannot be empty": "El Estado no debe estar vacio",

  "Please enter a valid 2 letter state abbreviation": "Ingrese una abreviatura valida de estado de 2 letras",

  "City cannot be empty": "Cuidad no debe estar vacio",

  "Zipcode be empty": "Codigo postal no debe estar vacio",

  "Phone number cannot be empty": "Numero de telefono no debe estar vacio",

  "Owner First Name cannot be empty": "Primer nombre del dueno no debe estar vacio",

  "Owner Last Name cannot be empty": "Apellido del dueno no debe estar vacio",

  "Owner Phone number cannot be empty": "Numero telefonico del dueno no debe estar vacio",

  "Owner Email cannot be empty": "Correo electronico del dueno no debe estar vacio",

  "Password cannot be empty": "Contrasena no debe estar vacio",

  "Phone can not be empty": "Numero telefonico no debe estar vacio",

  "Fleet": "Flota",

  "Service_Center": "Centro de servicio",

  'Logbook': 'Libro de registro',

  "The value must be greater than 0": "El valor debe ser mayor que 0",

  "Base service - $40\/month per unit. (Web Portal Accident App and Inspection App)": "Aplicacion de inspeccion y aplicacion de accidentes del portal web - $40\/mensual por unidad.",

  "Logbook App - $10\/month per unit. (Additional)": "Aplicacion de libro de registro - $10\/mensual por unidad. (Adicional)",

  "USA 60h\/7 days": "USA 60 horas \/ 7 días",

  "USA 70h\/8 days": "USA 70 horas \/ 8 días",

  "Texas 70h\/7 day": "Texas 70 horas \/ 7 días",

  "Canada 70h\/7 day South": "Canadá 70 horas \/ 7dias Sur",

  "Canada 80h\/7 day North": "Canadá 80 horas \/ 7 días Norte",

  "Canada 120h\/14 day South": "Canadá 120 horas \/ 14 días Sur",

  "Canada 120h\/14 day North": "Canadá 120 horas \/ 14 días Norte",

  "Mexico": "México",

  "Log time not available": "Tiempo de registro no esta disponible",

  "IDLE": "Inactivo",

  "0 MPH": "0 MPH    or   0 Millas por hora",

  "Total Active Drivers": "Conductores activos totales",

  "Available Trucks": "Trocas disponibles",

  "UD Logs": "Registros UD",

  "Employment Application": "Solicitud de empleo",

  "Medical Card": "Tarjeta médica",

  "Driver License": "Licencia de manejo",

  "MVR": "Historial de manejo",

  "Company Logotype": "Logotipo de la empresa",

  "MCS 150": "MCS 150",

  "Controlled Substance Documents": "Documentos sobre sustancias controladas",

  "Overweight Permits": "Permisos de sobrepeso",

  "Safety Manual": "Manual de seguridad",

  "Corporate Documents": "Documentos corporativos",

  "Driver Payroll Records": "Registro de nóminas de conductores",

  "Equipment list": "Lista de equipos",

  "Driver Trip Reports & Expense Records": "Reportes de viaje y registros de gastos del conductor",

  "MCS 90": "MCS 90",

  "Loss Runs": "Pérdida de carreras",

  "Company Contract": "Contrato de Empresa",

  "DOT Inspection Image": "Imagen de inspeccion DOT",

  "DOT Inspection Sound": "Sonido de inspeccion DOT",

  "DVIR Inspection Image": "Imagen de inspeccion DVIR",

  "DVIR Inspection Sound": "Sonido de inspeccion DVIR",

  "ADHOC Inspection Image": "Imagen de inspeccion ADHOC",

  "ADHOC Inspection Sound": "Sonido de inspeccion ADHOC",

  "Work Order Image": "Imagen de la orden de trabajo",

  "Parts Invoice": "Facturas de piezas",

  "Daily Log": "Registros diarios",

  "ADHOC": "ADHOC",

  "Incomplete Daily Log": "Registro diario incompleto",

  "Malfunction Report": "Informe de mal funcionamiento",

  "User Signature": "Firma del usuario",

  "Cab Card": "Tarjeta de cabina",

  "Insurance Card": "Tarjeta de seguro",

  "Repair Receipts": "Recibos de reparaciones",

  "Vehicle Registration": "Registro de vehículo",

  "Permits": "Permisos",

  "Trailer Registration": "Registro de remolques",

  "Individual Policy Template (DOCX)": "Plantilla de póliza individual (DOCX)",

  "Individual Policy Template (PDF)": "Plantilla de póliza individual (PDF)",

  "Individual Policy": "Póliza individual",

  "Import users": "Importar usuarios",

  "Import vehicles": "Importar vehiculos",

  "Import trailers": "Importar remolques",

  "Status history": "Hhistorial de estado",

  "Truck GPS history": "Historial de camiones GPS",

  "ELD Data File": "Archivos de datos ELD",

  "Fuel Receipt": "Recibos de combustible",

  "Delivery Receipt": "Recibo de entrega",

  "Dispatch Record": "Expedientes de despacho",

  "Bill of Lading": "Guia de carga",

  "Weigh Ticket": "Boleto de peso",

  "Communication record": "Registro de comunicacion",

  "Other Document": "Otros documentos",

  "Payment Receipt": "Recibos de pago",

  "Driver Report": "Registro de conductor",

  "Violation Report": "Informes de infraccion",

  "Odometer Jump Report": "Informe de salto del odometro",

  "Mobile Debug Log": "Registro de depuracion movil",

  "Driving Event Report": "Informe de evento de conduccion",

  "ELD Disconnection Report": "Registro de desconccion de ELD",

  "HOS Violations Detail Report": "Informe detallado de violaciones de HOS",

  "Unassigned Driver Report": "Informe de conductor no asignado",

  "Monthly Vehicle Maintenance Report": "Informe mensual de mantenimiento del vehiculo",

  "DVIR Report": "Registro DVIR",

  "keystore doesn't exists:": "Keystore no existe",

  "CURBSIDE FRONT AXLE": "EJE DELANTERO DEL LADO DE LA ACERA",

  "REAR": "TRASERA",

  "Front Headlights": "Faros Delanteros",

  "Front Flashers": "Intermitentes Delanteros",

  "Front Fog Lights": "Luces Antiniebla Delanteras",

  "Front Marker Lights": "Luces de Posicion Delanteras",

  "Front Engine Compartment": "Compartimento del motor",

  "Front Fluids": "Fluidos frontales",

  "Front Belts": "Cinturones frontales",

  "Front Hoses": "Mangueras frontales",

  "Front Compressor": "Compresor delantero",

  "Front Brakes": "Frenos delanteros",

  "Front Steering": "Delantera dirreccion",

  "Front Suspension": "Delantera suspension",

  "Curbside Front Axle Mirrors": "Espejos del eje delantero del lado de la acera",

  "Curbside Front Axle Tires": "Neumaticos del eje delantero del lado de la acera",

  "Curbside Front Axle Wheels": "Ruedas del eje delantero del lado de la acera",

  "Curbside Rear Axle Tires": "Neumaticos del eje trasero del lado de la acera",

  "Curbside Rear Axle Brakes": "Roturas del eje trasero en la acera",

  "Curbside Rear Axle Suspension": "Suspension del eje trasero en la acera",

  "Rear Exhaust": "Escape trasero",

  "Rear Fifth Wheel": "Quinta reda trasera",

  "Rear Frame": "Marco trasero",

  "Rear Lights": "Luces traseras",

  "Rear Flashers": "Destellos traseros",

  "Driver Rear Axle Tires": "Neumaticos del eje trasero del lado del conductor",

  "Driver Rear Axle Wheels": "Ruedas del eje trasero del conductor",

  "Driver Rear Axle Brakes": "Roturas del eje trasero del conductor",

  "Driver Rear Axle Suspension": "Suspension del eje trasero del conductor",

  "Driver Front Axle Mirrors": "Espejos del eje delantero del conductor",

  "Driver Front Axle Tires": "Neumaticos del eje delantero del conductor",

  "Driver Front Axle Wheels": "Ruedas del eje delantero del conductor",

  "Cab Horn": "Bocina de Cabina",

  "Cab Wipers\/Washers": "Limpia parabrisas\/lavadoras de cabina",

  "Cab Fire Extinguish": "Extintor de incendios de la cabina",

  "Cab Triangles": "Triangulos de cabina",

  "Cab Haz Mat Book": "Libro de Hazmat de la cabina",

  "Cab D.O.T. Paperwork": "Cabina D.O.T. papeleo",

  "Cab Brakes Bleed Down Test": "Prueba de purga de averias de cabina",

  "Cab Brakes Low Air Warning Test": "La cabina rompe la prueba de advertencia de aire bajo",

  "Cab Test Parking Brakes": "Descansos de estacionamiento de prueba de cabina",

  "Cab Brakes Test Stop 1st Rotation of Wheels": "Frenos de cabina parada de prueba 1 rotacion de ruedas",

  "Brake Connections": "Connecciones de frenos",

  "Coupling Devices": "Dispositivos de acoplamiento",

  "Coupling Pin": "Pasador de acoplamiento",

  "Doors": "Puertas",

  "Hitch": "Enganche",

  "Landing Gear": "Tren de aterrizaje",

  "Lights": "Luces",

  "Reflectors": "Reflectores",

  "Roof": "Techo",

  "Straps": "Correas",

  "Suspension System": "Sistema de suspencion",

  "Tarpaulin": "Lona alquitranada",

  "Wheels & Rims": "Ruedas y llantas",

  "Fleet Manager Has Changed The Subscription Tier": "El administrador de la flota ha cambiado el nivel de suscripcion",

  "Fleet Manager Has Assigned A Log For You": "El administrdor de la flota le ha asignado un registro",

  "User1 has sent you a co-driver request": "El usuario 1 le ha enviado una solicitud de copiloto",

  "User1 has assigned you a dailyLog": "Usuario 1 le ha asignado un registro diario",

  "User1 has completed the service request": "Usuario 1 ha completado la solicitud de servcio",

  "Minimum driver age allowed": "Edad minima del conductor permitida",

  "Allow Bluetooth Usage": "Permitir el uso de diente azul",

  "Company Name": "Nombre de empresa",

  "Manager Name": "Nombre del gerente",

  "Common": "Comun",

  "Email can not be empty": "Correo electronico no debe estar vacio",

  "Fleet Manager": "Gestor de flota",

  "Mechanic": "Mecánico",

  "Admin": "Administrador",

  "Developer": "Desarrollador",

  "Employee": "Empleado",

  "Reseller": "Distribuidor",

  "Reseller Employee": "Empleado del distribuidor",

  "Support": "Apoyo",

  "Service Manager": "Supervisor del servicio",

  "View Only Fleet Manager": "Ver solo el gestor de flota",

  "Last Name can not be empty": "Apellido no puede estar vacío",

  "First Name can not be empty": "Primer nombre no debe estar vacio",

  "Hire Date can not be empty": "Fecha de contrratacion no puede estar vacia",

  "Phone Number can not be empty": "numero telefonico no debe estar vacio",

  "Role cannot be empty": "La parte no puede estar vacio",

  "9 Pin": "Clavija 9",

  "6 Pin": "Clavija 6",

  "OBDII": "OBDII",

  "DUAL CAM": "Cámara dual",

  "Mack": "Mack",

  "Volvo": "Volvo",

  "Tractor Day Cab": "Cabina diurna del tractor",

  "Tractor Sleeper": "Sleeper del tractor",

  "Bobtail": "Cabina sin remolque",

  "Straight Truck": "Torton",

  "Box Truck": "Caja cerrada",

  "Pickup": "Pickup",

  "Private Passenger": "Pasajero privado",

  "Van": "Camioneta",

  "Approved": "Aprobado",

  "Closed": "Cerrado",

  "Un Assigned": "No asignado",

  "Maintenance": "Mantenimiento",

  "Repairs": "Reparaciones",

  "lubrication": "Lubricación",

  "No details available": "Detalles no estan disponibles",

  "Successfully submitted to FMCSA": "Enviado con éxito a FMCSA",

  "Failed to send csv!": "No se pudo enviar CSV!",

  "Failed to create daily log history csv": "No se pudo crear el historial de registro diario csv",

  "No Logs available for the driver for the selected date range!": "No hay registros disponibles para el conductor en el rango de fechas seleccionado",

  "No Logs available for the selected driver!": "No hay registros disponibles para el conductor seleccionado",

  "Failed to create daily log history csv!": "Mo se pudo crear el historeal de registro diario csv",

  "Unidentified Driver": "Conductor no identificado",

  "Required dailyLog field 'comment' is empty": "El espacio de registro diario obligatorio \"comentario\" esta vacio",

  "dailyLogEntries doesn't contain all readonly entries": "Las entradas de registro diarias no contienen todas las entradas de solo lectura",

  "File Format not allowed": "Formato de archivo no permitido",

  "Log Added Successfully": "Registro aregado exitosamente",

  "Log Exists for the date selected": "El registro existe para la fecha seleccionada",

  "Required dailyLog field 'note' is empty": "El espacio de registro diario obligatorio \"notas\" esta vacio",

  "No valid entries to save": "No hay entradas válidas para guardar",

  "successfully updated": "Actualizado exitosamente",

  "User not found with name: User1": "Usuario no encontrado con nombre: usuario 1",

  "Flex company cannot add more than 3 vehicles. This flex company already have 4 vehicle(s). This flex company already have 4 vehicle(s).": "La empresa flex no puede agregar mas de 3 vehiculos.  Esta empresa flex ya tiene 4 vehiculos.  Esta empresa ya tiene 4 vehiculos",

  "Invalid vehicle type": "Tipo de vehiculo es invalido",

  "Invalid device type": "Tipo de dispositivo es invalido",

  "Please provide Unit ID": "Proveer identificacion de unidad",

  "Please enter no more than 10 characters for Unit ID": "Ingresar no mas de 10 caracteres para la identificacion de la unidad",

  "Please provide Make": "Proveer marca",

  "Please provide Model": "Proveer modelo",

  "Please provide Next Maintenance Date": "Proveer fecha de la siguiente manutencion",

  "Driver with email email is being assigned to another vehicle in this file": "Conductor con correo electronico, el correo electronico se esta asignando a otro vehiculo en este archivo",

  "User with email email does not exist,": "Usuario con correo electronico, correo electronico no existe",

  "User with email email is not a driver,": "Usuario con correo electronico, correo electronico no es conductor",

  "Mechanic with email email does not exist,": "Mecanico con correo electronico, correo electronico no existe",

  "User with email email is not a mechanic,": "Usuario con correo electronico, correo electronico no es mecanico",

  "Trailer with vin Vin is being assigned to another vehicle in this file": "Trailer con vin, Vin se esta asignando a otro vehiculo en este archivo",

  "Trailer with vin Vin does not exist": "Trailer con vin, Vin no existe",

  "No such region Region": "No hay tal region, Region",

  "No such terminal Terminal is available, since the region is invalid": "No hay tal terminal, Terminal esta disponible, ya que la region es valida",

  "No such terminal Terminal for the region Region": "No hay tal terminal, Terminal para la region, Region",

  "No such department Department is available, since the terminal is invalid": "No hay tal departamento, Departamento esta disponible, ya que la terminal es valida",

  "No such department Department for the terminal Terminal": "No hay tal departamento, Departamento para la terminal, Terminal",

  "No such location Location is available, since the department is invalid": "No hay tal ubicacion, ubicacion esta disponible, ya que el departamento es valido",

  "No such location Location for the department Department": "No hay ubicacion, ubicacion para el departamento Departamento",

  "Please check the data is valid or header is correct": "Verifique que los datos sean validos o que el encabezado sea correcto",

  "Invalid trailer type": "Tipo de trailer es invalido",

  "Please enter Unit ID between 1 to 10 characters length": "Ingresar identificacion de unidad entre 1 a 10 caracteres de longitud",

  "Vehicle with VIN VIN does not exist in our system": "Vehiculo con Vin, Vin no existe en nuestro sistema",

  "First name should have at least 2 characters": "Primer nombre debe tener al menos 2 caracteres",

  "Please provide First Name": "Proporcione el primer nombre",

  "Please provide less than 30 characters for first name": "Proporcionar menos de 30 caracteres para el primer nombre",

  "Please provide Last Name": "Proporcionar el apellido",

  "Last name should have at least 2 characters": "Apellido debe tener al menos 2 caracteres",

  "Please provide less than 30 characters for last name": "Proporcionar menos de 30 caracteres para el apellido",

  "Please provide Phone": "Proporcionar numero telefonico",

  "Please provide Email": "Proporcionar correo electronico",

  "Please provide Hire Date": "Proporcionar fecha de contratacion",

  "Role Role1 does not exist": "Parte, parte 1 no existe",

  "Role1 role is not allowed": "Parte 1, parte no es permitido",

  "Driver should have a licenseNumber": "Conductor debera terner numero de licencia",

  "Please enter no more than 20 characters for license number": "Ingresar no mas de 20 caracteres para el numero de licencia",

  "Driver should have a State": "Conductor debera tener un Estado",

  "Driver should have Other, because the licenseState is Non-US": "El conductor debe tener otro, porque el estado de la licencia no es de EE. UU.",

  "This vehicle is already assigned to another Mechanic.": "El vehiculo ya esta asignado a otro Mecanico",

  "Since the active vehicle count is less than the 75% of total vehicles, 75% of total vehicle count is taken": "Dado que el recuento de vehiculos activos es inferior al 75% del total de vehiculos, se toma el 75% del recuento total de vehiculos",

  "Active vehicles taken": "Vehiculos activos tomados",

  "Parts": "Piezas",

  "Tyre": "Llantas",

  "Mirror": "Espejos",

  "Safety Analytics Report By Vehicle For May 5 to May 8": "Informe de analisis de seguridad por vehiculo del 5 al 8 de Mayo",

  "Confidential Information. Property of Gorilla Safety": "Informacion confidencial:  Propiedad de seguridad de Gorilla",

  "Page: 4": "Pagina:  4",

  "Printed For: User1    Printed Date: 05\/44\/2021": "Impreso para:  Usuario 1      Fecho impresa:  5\/44\/2021",

  "Total Cost ($) : 666": "Costo total ($): 666",

  "Workorder Parts": "Partes de la orden de Trabajo",

  "HOS Violations Detail": "Detalles de violaciones de HOS",

  "HOS Violations Summary": "Resumen de violaciones HOS",

  "Inspection Reports Detail": "Reporte detallados de inspeccion",

  "PAYMENT INVOICE": "Factura de pago",

  "Payment Date": "Fecha de pago",

  "Active trucks": "Trocas activas",

  "Work order #": "Numero de orden de trabajo:",

  "Trailer :": "Trailer",

  "Vehicle :": "Vehiculo",

  "Quantity": "Cantidad",

  "Cost ($)": "Costo ($)",

  "Event Start": "Inicio de evento",

  "Event End": "Final de evento",

  "Duration": "Duracion",

  "Start Odo(mi)": "Iniciar odometro (mi)",

  "End Odo(mi)": "Odometro final (mi)",

  "Distance(mi)": "Distancia (mi)",

  "No Driving Events": "No hay eventos de conduccion",

  "Event Description": "Descripcion del evento",

  "Event Date\/Time (in UTC)": "Fecha\/Tiempo de evento (en UTC)",

  "Actual Speed (mi)": "Velocidad actual (mi)",

  "Vehicle : Vehicle1                                 Total Violations : 5": "Vehiculo: Vehiculo 1      Violaciones totales:  5",

  "Something went wrong while signing contract :": "Algo salio mal al firmar el contrato:",

  "Confirmation of Order": "Confirmacion de pedido",

  "Thank you for signing up for the Tier1 service tier. The following is a breakdown of cost based on the service tier selected. Note that the cost is subject to change if upgraded to a higher service tier.": "Gracias por registrarse en el nivel de servicio nivel 1.  El siguiente es undesglose del costo segun el nivel de servicio seleccionado.  Tenga en cuenta que el costo esta sujeto a cambios si se actualiza a un nivel de servicio superior bajo.",

  "Total Cost Per Month($)": "Costo total mensual ($)",

  "Initial Truck Count": "Recuento inicial de camiones",

  "Cost Per Truck ($)": "Costo por troca ($)",

  "Contract Term:": "Terminos de contrato",

  "Violations": "Violaciones",

  "Driver Phone": "Numero telefonico",

  "Flag": "Bandera",

  "Driver went over the permitted driving hours": "El conductor paso las horas de conduccion permitidas",

  "Driver went over the permitted cycle hours": "El conductor paso las horas del ciclo permitido",

  "Driver did not sign the logbook": "Conductor no firmo libro de registro",

  "Driver did not complete the DVIR": "Conductor no completo DVIR",

  "Driver has not taken a complete break": "Conductor no ha tomado un descanso completo",

  "ELD Disconnects Detail": "Detalles de desconeccion ELD",

  "Date Range   Nov 1 - Nov 3": "Rango de fecha  Nov1 - Nov 3",

  "Disconnect Time": "Tiempo desconectado",

  "Disconnect Location": "Ubicacion de desconexion",

  "Reconnect Time": "Tiempo de reconexion",

  "Reconnect Location": "Reconectar ubicacion",

  "Disconnect Odometer (mi)": "Desconectar odometro (mi)",

  "Reconnect Odometer (mi)": "Reconectar odometro (mi)",

  "Distance (mi)": "Distancio (mi)",

  "No ELD Disconnect": "No ELD desconectado",

  "Disconnect Timestamp": "Desconectar marca de tiempo",

  "Reconnect Timestamp": "Reconectar marca de tiempo",

  "No Odometer Jump Events": "Sin eventos de salto de odometro",

  "No malfunction for the vehicle": "Ningun mal funcionamiento del vehiculo",

  "Assigned To": "Asignado a",

  "No Unassigned Driver Logs": "Sin registro de controladores no asignados",

  "No Inspection Reports": "Sin informes de inspeccion",

  "Total Inspection Reports": "Reportes total de inspeccion",

  "Total Reports with Defects": "Total reportes con defectos",

  "Trailer Defects": "Defectos del remolque",

  "Vehicle Defects": "Defectos del vehiculo",

  "Time": "Tiempo",

  "Odometer (mi)": "Odometro (mi)",

  "\nFor the month of: Jan 2021": "Para el mes de: Enero 2021",

  "This is a combination Service, Repair, Tire and Brake Condition Report. Report is to be completed and turned in within (5) days of the reporting month for the tractor to stay in operating status. FMCSR section 396.3 & 396.5 requires carriers to maintain a record of all maintenance performed with receipts on every tractor owned, leased, or rented.": "Este es un informe combinado de servicio reparacion, llantas y condiciones de rotura.  El informe debe completarse y entregarse dentro de los(5) dias posteriores al mes del informe para que el tractor permanezca en estado operativo.  Las secciones 396.3 y 396.5 de FMCSR requieren que los transportistas mantengan un registro de todo el mantenimiento realizado con recibos de cada tractor de propiedad, arrendando o alquilado",

  "Owner\/Driver:": "Dueno\/Conductor",

  "Year:": "Ano",

  "COMPLETION OF THIS FORM IS REQUIRED BY FEDERAL LAW": "COMPLETAR ESTE FORMULARIO ES REQUERIDO POR LA LEY FEDERAL",

  "REPAIRS:": "Refaccion",

  "List all repairs, parts, or equipment installed for the month. If repairs are a result of a violation, please mark the “DOT inspection” column.": "Enumere todas las reparaciones, piezas o equipos instalados durante el mes. Si las reparaciones son el resultado de una infraccion, marque la columna \"INSPECCION DOT\"",

  "Description of Repair": "Descripcion de la reparacion",

  "New or Replacement Part": "Pieza nueva o de repuesto",

  "Repaired\nper DOT\ninspection": "Reparado por DOT inspeccion",

  "No commmon repair details found": "No se encontraron detalles de reparacion comunes",

  "LUBRICATION:": "Lubricacion",

  "List all lube work (oil changes) on engine, transmission, differential, and 5 th wheel. Also list filter changes.": "Enumere todo el trabajo de lubricacion (cambios de aceite) en el motor, la transmision, el diderencial y la quinta rueda.  Tambien enumerar los cambios de filtro",

  "No lubrication repair details found": "No se encontraron detalles de reparacion de lubricacion",

  "Tires:": "Llantas",

  "List all flats repaired, tire changes, rotations, air pressure checks, tread checks, and new replacements.": "Enumerar todos los pinchazos reparados, cambios de neumaticos, rotaciones, controles de presion de aire, controles de la banda de rodamiento y nuevos reemplazos",

  "No Tire repair details found": "No se encuentran detalles de reparacion de llantas",

  "Brakes:": "Frenos",

  "List all repairs\/maintenance to braking system (brake shoes, hub gaskets,brake lines, wheelseals, brake adjustments, or brake kits)": "Enumere toda reparaciones\/mantenimiento del sistema de frenos (zapatas de freno, empaquetaduras de cubo, lineas de freno, sellos de rueda, ajustes de freno o kits de freno",

  "No Brake repair details found": "No se encuentran detalles de reparacion de frenos",

  "History Of Driver": "Historial de conductor",

  "No Alerts Available": "Alertas disponible",

  "No Driver Status History": "No estatus historial de conductor",

  "Truck ID": "Identificacion de troca",

  "Geocoded Location": "Ubicacion geocodificada",

  "Updated Time": "Hora actualizada",

  "MPH": "MPH   or   Millas por hora",

  "Cycle Limit": "Limite de ciclo",

  "14 Hour Shift Limit": "Limite de turno de 14 horas",

  "30 Minute Break Required": "Se requiere 30 minutos de descanso",

  "11 Hour Driving Limit": "Limite de conduccion de 11 horas",

  "Drivers Audited": "Conductoras auditadas",

  "HOS Violations": "Violaciones HOS",

  "Logs Audited": "Registros auditados",

  "# of Drivers": "Numero de conductores",

  "# of Violations": "Numero de violaciones",

  "Int Location": "Ubicacion de INT",

  "Drivers with HOS Violations": "Conductores con violaciones HOS",

  "Logs with HOS Violations": "Registros con violaciones HOS",

  "Start": "Iniciar",

  "No HOS Violations": "No violaciones HOS",

  "No user found": "No se encuentra usuario",

  "Unidentified": "No identificado",

  "Default Region": "Region defecto",

  "Gorilla Safety Signed Contract 2021": "Gorilla Safety firmo contrato 2021",

  "New User Registered": "Nuevo usuario registrado",

  "Registration Confirmation - FleetLocate": "Registracion confirmada - Flota ubicada",

  "Your Gorilla Safety subscription for Company Name has been upgraded to Tier1 as per your request": "Su suscripcion de Gorlla Safety o el nombre de la empresa se ha actualizado al nivel1 segun su solicitud",

  "Gorilla Safety Upgradation Successful": "Gorilla Safety actualizada exitosamente",

  "No subscription plan found for Fleetlocate": "No se ha encontrado ningun plan de suscripcion para la localizacion de la flota",

  "Invalid User Id!": "Identificacion de usuario es valido",

  "Not Connected": "No esta conectado",

  "Log Signed": "Registro firmado",

  "Auto": "Auto",

  "Engine OFF": "Motor apagado",

  "Engine ON": "Motor prendido",

  "Adverse Driving Condition": "Condicion de conduccion adversa",

  "No Remarks Found": "No se encuentran commentarios",

  "Illegal inspection type DVIR": "Ilegal inspeccion tipo DVIR",

  "DAILY LOG HISTORY": "Registro historial diario",

  "ELD": "ELD",

  "resetHelp": "Le ayudaremos a restablecerlo y volver a la pista",

  "View Sample": "Ver muestra",

  "Back to Login": "Atras para iniciar sesion",

  "Email address": "Domicilio de correo electronico",

  "NB: This will send files to FMCSA via email or Web Services as outlined in Appendix A to Subpart B of Part 395": "NB:  Esto mandara archivos a FMCSA via correo electronico o Servicios de web como se describe en el apendice A de la subparte B de la parte 395",

  "Export": "Exportar",

  "Export Data": "Exportar datos",

  "Our apologies": "Nuestras disculpas",

  "Please send us feedback": "Por favor envienos su comentarios",

  "Corporate Office": "Oficina Corporativa",

  "Office": "Oficina",

  "Patent pending": "Patente pendiente",

  "Copyright 2020": "Derechos 2020",

  "Privacy & Legal": "Privacidad y Legal",

  "Spanish": "Espanol",

  "DOT No.": "Numero de DOT",

  "MANAGE DAILY DOCUMENTS": "Administrar documentos diarios",

  "Compliance Notifications": "Notificaciones de cumplimiento",

  "Submit": "Enviar",

  "Unhandled": "No manejado",

  "Date To": "Fecha para",

  "No data available in table": "No hay datos disponible en la tabla",

  "coDriver Id": "Identificacion de copiloto",

  "note": "Nota",

  "The confirm password is not match with password": "Confirmacion de la contrasena no coincide con la contrasena",

  "Please enter valid email format": "Ingrese un formato de correo electronico valido",

  "Please enter a valid number": "Ingrese un numero valido",

  "Must be greater than zero": "Debe ser mayor que un zero",

  "Please enter no more than 10 characters": "Ingrese no mas de 10 caracteres",

  "Clear All": "Despejar todo",

  "Document": "Documento",

  "User Credentials": "Credenciales del usuario",

  "Employee Id": "Identificacion de Empleado",

  "Departments": "Departamentos",

  "Vehicle ID": "Identificación del vehículo",

  "License Number": "Numero de licencia",

  "Page not found": "No se encuentra la pagina",

  "USER MAIN INFORMATION": "Informacion principal del usurio",

  "OK": "OK",

  "Export All": "Exportar todo",

  "Please enter the same value again.": "Ingrese el mismo valor otra vez",

  "Region": "Region",

  "Terminal": "Terminal",

  "Department": "Departamento",

  "Dot Officer Code": "Codigo de Oficial de DOT",

  "Please Select": "Seleccione",

  "Bulk Download Reports": "Informes de descarga masiva",

  "Import": "Importaciones",

  "Template": "Plantilla",

  "Add": "Agregar",

  "Are you sure?": "¿Está seguro?",

  "You will not be able to recover this vehicle!": "No se podra recuperar este vehiculo",

  "TimeZone": "Zona horaria",

  "Device Type": "Tipo de dispositivo",

  "Policies and Procedures": "Polizas y procedimientos",

  "Other Contact": "Otros contactos",

  "Next Maintenance Mileage": "Siguiente mantenimiento de millaje",

  "Trailer Information": "Informacion de trailer",

  "Vehicle Information": "Informacion de vehiculo",

  "Current Odometer": "Odometro actual",

  "Hardware Device": "Dispositivo",

  "VIN number must be 17-character long. Numbers and letters only. I, O, or Q are not allowed": "Numero de VIN debe ser de 17 caracteres. Numeros y letras solamente. I, O, o Q no son permitidos",

  "Main Address": "Domicilio principal",

  "Terminal Address": "Domicilio de terminal",

  "Time Zone Offset From UTC": "DESPLAZAMIENTO DE ZONA HORARIA DE UTC",

  "Location Of Log Signing": "Ubicacion de la firma de registros",

  "Please enter at least 2 characters.": "Ingresar por lo menos 2 caracteres",

  "Please fill in the correct format(844-636-1360).": "Llenar el formato correcto (844-636-1360)",

  "Applied Filters :": "Aplicar filtros",

  "Daily Log for": "Registros diarios para",

  "Refresh": "Refrescar",

  "You will not be able to recover this user!": "No podra recuperar este usuario",

  "You will activate this user!": "Activaras este usuario",

  "Minimum 1 row is required": "Se requiere un minimo de 1 fila",

  "Yes, delete it!": "Si, eliminela",

  "Yes, accept it!": "Si acceptela",

  "Nothing to display": "Nada que mostrar",

  "Show": "Demuestre",

  "Save Changes": "Guardar cambios",

  "Data has been imported successfully": "Datos han sido importados exitosamente",

  "Please Accept Terms and Conditions To Continue": "Acepte Terminos y Coniciones para continuar",

  "User": "Usuario",

  "Driving state": "Estado de conduccion",

  "Confirm": "Confirmar",

  "Please select atleast one filter": "Seleccione al menos un filtro",

  "Name on Card": "Nombre en la tarjeta",

  "No Data to plot": "No hay datos en la parcela",

  "Please enter at least 4 characters.": "Ingresar al menos 4 caeacteres",

  "Please enter no more than 9 characters.": "Ingresar no mas de 9 caracteres",

  "Card Details Updated Successfully": "Los detalles de la tarjeta se actualizaron correctamente",

  "USDOT Number deleted successfully": "USDOT numero eliminado exitosamente",

  "Region deleted successfully": "Region eliminado exitosamente",

  "Region added successfully": "Region agregado exitosamente",

  "Region updated successfully": "Region actualizado exitosamente",

  "Terminal added successfully": "Terminal agregado exitosamente",

  "Terminal updated successfully": "Terminal actualizado exitosamente",

  "Terminal deleted successfully": "Terminal eliminado exitosamente",

  "Department added successfully": "Departamento agregado exitosamente",

  "Department updated successfully": "Departamento actualizado exitosamente",

  "Department deleted successfully": "Departamento eliminado exitosamente",

  "Location added successfully": "Ubicacion agregado exitosamente",

  "Location updated successfully": "Ubicacion actualizado exitosamente",

  "Location deleted successfully": "Ubicacion eliminado exitosamente",

  "Parts added successfully": "Piezas agregadas exitosamente",

  "Summary": "Sumario",

  "Print": "Imprimir",

  "No data available": "No hay datos disponibles",

  "Privacy Policy": "Polizas privadas",

  "Your account is not registered in Camera portal. Please register in camera portal and try again.": "Su cuenta no esta registrada en camara portal.  Registrese en camara portal e intentelo de nuevo",

  "This feature is not configured for your account.": "Esta funccion no esta configurada para su cuenta",

  "Switch to New View": "Cambiar a nueva vista",

  "Feedback": "Reaccion",

  "Developer Permission Requests": "Solicitudes de permiso de descanso",

  "IFTA Report": "IFTA Reporte",

  "Fuel Consumption Report": "Reporte sobre el consumo de combustible",

  "Daily Documents": "Documentos diarios",

  "DOT Audit": "DOT Auditoria",

  "USDOT No. Management": "USDOT Numero de adiministracion",

  "Filters": "Filtros",

  "CSA Violations": "CSA Violaciones",

  "Camera": "Camara",

  "Companies": "Empresas   OR   Companias",

  "Freight": "Transporte",

  "You have unassigned Unidentified Driving Time. Please go to the logs tab and assign these logs to the right driver.": "Tiene tiempo de conduccion no identificado sin asignar.  Vaya a la pestana de registros y asigne estos registros al controlador correcto",

  "MANAGE USERS - ON DUTY": "Administrar usuarios - en servicio",

  "MANAGE USERS - SLEEPER": "Administrar usuarios - dormitorio",

  "MANAGE USERS - OFF DUTY": "Administrar usuarios - fuera de servicio",

  "Driver Behavior": "Comportamiento del conductor",

  "Vehicle Status": "Estatus del vehiculo",

  "Last Known Location": "Ultima ubicacion conocida",

  "Unit": "Unidad",

  "Drive Time Remaining": "Tiempo de conduccion restante",

  "Time Until Break": "Tiempo hasta el descanso",

  "Duty Cycle Remaining": "Ciclo de trabajo restante",

  "Current Status": "Actual estatus",

  "Engine Speed": "Velocidad de motor",

  "Last Updated": "Ultima actualizacion",

  "Drive Time": "Tiempo de manejo",

  "On Duty Time": "Tiempo en servicio",

  "Enable Notification": "Habilitar la notificacion",

  "Manage Violations": "Administrar violaciones",

  "CSA Snapshot": "CSA Snapshot",

  "Sleeper": "Dormitorio",

  "Service Temporarily Unavailable": "Servicio temporalmente disponible",

  "Internal server error": "Error del servidor interno",

  "Manage Companies": "Administrar empresas",

  "WORK ORDER DETAILS": "Detalles de pedidos de trabajo",

  "Edit Trailer": "Editar tráiler",

  "Vehicle for mechanic": "Vehículo para el mecánico",

  "Vehicle for driver": "Vehículo para el conductor",

  "Enable Non-DOT Trip": "Habilitar viaje sin DOT",

  "Enable Personal Conveyance": "Habilitar transporte personal",

  "Exempt from using ELD": "Exento de utilizar el ELD",

  "Expiration": "Vencimiento",

  "View History": "Ver historial",

  "Uploaded": "Descargado",

  "MM/DD/YYYY": "MM/DD/AAAA",

  "View All": "Ver todo",

  "Expiration Date": "Fecha de vencimiento",

  "Select File to upload": "Seleccionar archivo para cargar",

  "EDIT PROFILE": "Editar perfil",

  "Driver Status History": "Estatus historial de conductor",

  "Quick filters:": "Filtros rapidos",

  "Service Managers": "Servicio de gerente",

  "Manage Mechanics": "Administrar mecanicos",

  "Search Mechanic": "Buscar mecanicos",

  "Signed Logs": "Registros firmados",

  "Real-time\/Unsigned Logs": "Tiempo-Real\/Registros sin firmar",

  "Unidentified driver logs": "Registros de conductores no identificados",

  "Add logs": "Agregar registros",

  "Export dailylog signed status": "Exportar registro diario estado firmado",

  "LogBook": "Libro de registro",

  "Unassigned Drive Time": "Tiempo de manejo no asignado",

  "Unidentified Driver Profile": "Perfil del conductor no identificado",

  "View Documents": "Ver documentos",

  "No violation data for the day": "No hay datos de violacion por el dia",

  "Refills History": "Historial de recargas",

  "Co-Driver Name": "Nombre de copiloto",

  "Log Signing Location": "Ubicacion de firma de registro",

  "Verification Status": "Vereficacion de estatus",

  "State Modifier": "Modificadora de Estado",

  "Time From": "Tiempo desde",

  "Time To": "Tiempo para",

  "Latest Fueling Location": "Ultima ubicacion de combustible",

  "Add new row": "Agregar nueva fila",

  "Update events": "Actualizar eventos",

  "Update Graph": "Actualizar grafico",

  "Invalid request. Click here to go back to dashboard": "Solicitud no valida.  Precione aqui para volver al tablero de control",

  "GO BACK": "Regrese",

  "Oil Field Waiting": "Campo de petrolero esperando",

  "Emp Id": "Identificacion del empleado",

  "Import User Template": "Importar plantilla de usuario",

  "Export Users": "Exportar usuarios",

  "Yes, deactivate user!": "Si, desactive usuario",

  "Yes, activate it!": "Si, activelo",

  "Manufact": "Fabricar",

  "List of Trailers": "Enumeracion de trailers",

  "Roadside Inspections": "Inspeccion en carretera",

  "Export Vehicles": "Exportar vehiculos",
  "Export Trailers": "Exportar trailers",

  "Import Vehicles Template": "Importar plantilla de vehiculo",

  "Import Trailers Template": "Importar plantilla de remolques",

  "Track Vehicle": "Pista de vehiculo",

  "Date\/Time From": "Fecha\/Tiempo de",

  "Date\/Time To": "Fecha\/Tiempo a",

  "Seat Belt Status": "Estatus de cinturon",

  "Send message": "Mandar mensaje",

  "To: Search...": "Para:  Buscar",

  "New Conversation": "Nueva conversacion",

  "Broadcast": "Emision",

  "You will not be able to recover this trailer!": "No podra recuperar este trailer",

  "Driver ID": "Identificacion de conductor",

  "Defect Found": "Se encontro un defecto",

  "Download Reports": "Descargar reportes",

  "View Witnesses": "Ver testigos",

  "View Receipt": "Ver recibos",

  "Developer Name": "Nombre del desarrollador",

  "Terminals and Departments": "Terminales y Departamentos",

  "No location added": "No se agrego ninguna ubicacion",

  "No departments under this terminal": "No departamentos bajo esta terminal",

  "Add Terminal": "Agregar terminal",

  "Edit Terminal": "Editar terminal",

  "Add Region": "Agregar region",

  "Edit Region": "Editar region",

  "Region Name": "Nombre de region",

  "Add Department": "Agregar departamento",

  "Edit Department": "Editar departamento",

  "Add Location": "Agregar ubicacion",

  "Edit Location": "Editar ubicacion",

  "Delete Terminal": "Eliminar terminal",

  "Delete Department": "Eliminar departamento",

  "Service Centers": "Centros de Servicio",

  "Set Filter": "Establecer filtros",

  "FLEET MANAGER INFORMATION": "Informacion del administrador de la flota",

  "Maintenance Period (Months)": "Periodo de Mantenimiento (Meses)",

  "Subscription Tier": "Suscripcion de nivel",

  "Contract Length": "Duracion del contrato",

  "Create Account": "Crear una cuenta",

  "Producer Code": "Codigo de productor",

  "I agree to the": "Estoy de acuerdo con la",

  "Terms of Use": "Terminos de uso",

  "Total amount: $": "Monto Total: $",

  "PAYMENT CONFIRMATION": "Confirmacion de pago",

  "Sales Tax ($)": "Impuesto de venta($)",

  "Discount (%) (if any)": "Descuento (%) (si hay)",

  "Total Amount ($)": "Monto Total: $",

  "I accept the following terms and conditions.": "Acepto los siguientes terminos y condiciones",

  "DVIR Link": "Enlace DVIR",

  "DVIR Status": "Estatus DVIR",

  "Roadside DOT Inspection": "Inspeccion DOT en carretera",

  "Work Order": "El pedido de trabajo",

  "Work Order Status": "Estatus del pedido de trabajo",

  "OOS": "OOS",

  "Severity": "Gravedad",

  "Download Truck GPS history": "Descargar el historial del GPS del camion",

  "Hide States with no mileage": "Ocultar estados sin kilometraje",

  "Active Vehicles": "Vehiculos activos",

  "Deactivated Vehicles": "Desactivar vehiculos",

  "Total Miles": "Millaje total",

  "Jurisdiction": "Jurisdiccion",

  "Current Drivers": "Actual conductores",

  "Miles per Gallon": "Millaje por galon",

  "Gallons": "Galones",

  "USDot No.": "USDOT Numero",

  "Name of Carrier": "Nombre del transportista",

  "Main Office Address": "Domicilio de Oficina principal",

  "Zip": "Codigo postal",

  "ADD NEW DOT": "AGREGAR NUEVO DOT",

  "EDIT DOT": "EDITAR DOT",

  "Message": "Mensaje",

  "Send": "Enviar",

  "Search By User": "Buscar por usuario",

  "Inspection Type": "Tipo de inspeccion",

  "Inspection Reports": "Informes de inspeccion",

  "Advanced DVIR": "Avanzada DVIR",

  "Bulk Download Report": "Informe de descarga masiva",

  "Section": "Seccion",

  "Configuration type or section name not entered": "Tiempo de configuracion o nombre de seccion no ingresado",

  "Custom DVIR": "Personalizada DVIR",

  "Search By Company": "Buscar por empresa",

  "Search By Mechanic": "Buscar por mecanico",

  "Has Defects?": "Tiene defectos?",

  "Work Order #": "Numeracion de pedido de trabajo",

  "Reported Date": "Fecha reportada",

  "Scheduled Date": "Cita agendada",

  "Repair Cost($)": "Costo de reparacion ($)",

  "Open WorkOrders": "Ordenes de trabajo abiertas",

  "Closed WorkOrders": "Pedidos de trabajo cerrado",

  "Add WorkOrder": "Agregar pedido de trabajo",

  "Unit Type": "Tipo de unidad",

  "INSPECTION DETAILS": "DETALLES DE INSPECCION",

  "Labor Cost ($)": "Costo laboral ($)",

  "Parts Cost ($)": "Costo de piezas ($)",

  "Total Cost ($)": "Monto Total: $",

  "Scheduled": "Programado",

  "View Picture": "Ver fotografia",

  "No Report": "No hay informes",

  "Assign to another Service Center": "Asignar a otro Centro de Servicio",

  "Assign Service Request": "Asignar solictud de servicio",

  "Service Request assigned to a service center. Unable to make this change!": "Solicitud de servicio asignada a un centro de servicio. Incapaz de hacer este cambio",

  "Work Order Has Been Updated.": "Pedido de trabajo se ha acutualizdo",

  "Service Repair Request Has Been Updated.": "Se ha actualizado la solicitud de rearacion del servicio",

  "# in Inventory": "Numero de inventario",

  "Cost Per Unit": "Costo por unidad",

  "Add Part": "Agregara pieza",

  "Please enter a value greater than or equal to 0.": "Ingrese un valor mayor o igual a 0",

  "Maintenance Period": "Periodo de mantenimiento",

  "Other Location Contact Person": "Algun otra ubicacion para contactar a la persona",

  "Other Location Address": "Otra ubicacion de domicilio",

  "Other Location Phone Number": "Otro numero de telefono",

  "Default Cycle Rule": "Regla de ciclo predeterminada",

  "Payment Information": "Informacion de pago",

  "Cancel Subscription": "Cancelar de suscripcion",

  "Update Credit Card Details": "Actualizar detalles de tarjeta de credito",

  "Skip Vehicle Filter Search": "Omitir busqueda de filtro de vehiculo",

  "Enable Oil Field Waiting": "Habilitar campos petroleros esperando",

  "Advance Settings": "Configuraciones avanzadas",

  "IFTA": "IFTA",

  "Company Info for": "Informacion de empresa para",

  "Contract History": "Contrato historial",

  "Contract Start Date": "Fecha de inicio del contrato",

  "Next Billing Date": "Siguiente fecha de facturacion",

  "Payment History for Test Tracks Company": "Historial de pagos para la empresa de pistas de prueba",

  "Created Date": "Fecha de creacion",

  "Paid Date": "Fecha de pago",

  "Unit Count": "Ciuenta de unidad",

  "Start Date": "Fecha de inicio",

  "End Date": "Fecha final",

  "No.Of Days": "Numero de dias",

  "Pay With Card": "Pagar con tarjeta",

  "Payment Details": "Detalles de pago",

  "You have active contract from": "Tiene contrato activo de",

  "till": "Hasta",

  "Document Type": "Tipo de documento",

  "Customer Name\/Job Name": "Nombre de cliente\/titulo de trabajo",

  "Upload New Document": "Acutualizar nuevo documento",

  "Success": "Exitoso",

  "Duty Status": "Estado del servicio",

  "Driver Performance Report": "Reporte del rendimiento del conductor",

  "Edited Data Report": "Reporte de datos editados",

  "Rejected Edits": "Ediciones rechazadas",

  "ELD Disconnect Report": "Reporte de desconexión del ELD",

  "Unassigned Driving Report": "Reporte de manejo no asignado",

  "HOS Violations Details": "Detalle de las infracciones de las horas de servicio",

  "Bill Of lading Report": "Reporte sobre el conocimiento de embarque",

  "HOS Violations Report": "Reporte de infracciones",

  "Unsigned Log Report": "Reporte de registro sin firma",

  "Failed Inspection Report": "Reporte de inspección fallido",

  "Unidentified driving report": "Reporte de conducción no identificado",

  "Monthly HOS Driver Violations Report": "Reporte mensual de infracciones de las horas de servicio de los conductores",

  "Monthly Unsigned Log report": "Reporte mensual de registro sin firma",

  "Hard Acceleration": "Aceleracion dura",

  "Hard Deceleration": "Desaceleracion duro",

  "Speeding": "Exceso de velocidad",

  "Driving Hours Exceeded": "Horas de condicion excedidas",

  "Fuel Economy": "Economia de combustible",

  "Non Buckled Seat Belt Warning": "Advenrtencia de cinturon de seguridad no abrochada",

  "Hard Turn": "Vuelta dura",

  "to go back to Inspections": "Regrese a inspecciones",

  "Search Companies": "Busque y agregue copilotos presionando en la barra de",

  "Area": "Busqueda de empresas",

  "Comments by Mechanic": "Comentarios de mecanico",

  "Comment": "Comentario",

  "Fix Status": "Estatus de compostura",

  "View Photo": "Ver fotografia",

  "RIGHTS AND TERMS FOR APP": "Derechos y terminos para la aplicacion",

  "General Prohibitions": "Prohibiciones generales",

  "IT IS STRICTLY FORBIDDEN TO USE THE CLUTCHELD APP WHILE DRIVING": "Es estrictamente prohibido usar el EMBRAGUE ELD mientras conduce",

  "You further agree not to do any of the following:": "Usted acepta no hacer nada de lo siguiente:",

  "1. Post, upload, publish, submit or transmit any User Content that: (in) infringes, misappropriates or violates a third party's patent, copyright, trademark, trade secret, moral rights or other intellectual property rights, or rights of publicity or privacy; (ii) violates, or encourages any conduct that would violate, any applicable law or regulation or would give rise to civil liability; (iii) is fraudulent, false, misleading or deceptive; (iv) is defamatory, obscene, pornographic, vulgar or offensive; (v) promotes discrimination, bigotry, racism, hatred, harassment or harm against any individual or group; (vi) is violent or threatening or promotes violence or actions that are threatening to any person or entity; or (vii) promotes illegal or harmful activities or substances. 2. Use, display, mirror or frame the Services, or any individual element within the Services, ClutchELD's name, any ClutchELD trademark, logo or other proprietary information, or the layout and design of any page or form contained on a page, without ClutchELD's express written consent; 3. Access, tamper with, or use non-public areas of the Services, ClutchELD's computer systems, or the technical delivery systems of ClutchELD's providers; 4. Attempt to probe, scan, or test the vulnerability of any ClutchELD system or network or breach any security or authentication measures; 5. Avoid, bypass, remove, deactivate, impair, descramble or otherwise circumvent any technological measure implemented by ClutchELD or any of ClutchELD's providers or any other third party (including another user) to protect the Services or User Content; 6. Attempt to access or search the Services or User Content or download User Content from the Services through the use of any engine, software, tool, agent, device or mechanism (including spiders, robots, crawlers, data mining tools or the like) other than the software and\/or search agents provided by ClutchELD or other generally available third party web browsers; 7. Send any unsolicited or unauthorized advertising, promotional materials, email, junk mail, spam, chain letters or other form of solicitation; 8. Use any meta tags or other hidden text or metadata utilizing a ClutchELD trademark, logo, URL or product name without ClutchELD's express written consent; 9. Use the Services or User Content for the benefit of any third party or in any manner not permitted by these Terms; 10. Forge any TCP\/IP packet header or any part of the header information in any email or newsgroup posting, or in any way use the Services or User Content to send altered, deceptive or false source-identifying information; 11. Attempt to decipher, decompile, disassemble or reverse engineer any of the software used to provide the Services or User Content; 12. Interfere with, or attempt to interfere with, the access of any user, host or network, including, without limitation, sending a virus, overloading, flooding, spamming, or mail-bombing the Services; 13. Collect or store any personally identifiable information from the Services from other users of the Services without their express permission; 14. Impersonate or misrepresent your affiliation with any person or entity; 15. Violate any applicable law or regulation; or 16. Encourage or enable any other individual to do any of the foregoing.": "1.Poner, actualizar, publicar, enviar o transmitir cualquier contenido que:(dentro) infringe, desapropiadas o violaciones a terceras personas patente, derechos, marca comercial, secreta comercial, derechos morales, o algun otro derecho de propiedad intelectual, o derechos de privacidad de publicidad; (ii) violar a animar conducta de violacion, qualquier regla aplicable o regulacion o dar lugar a responsabilidad civil; (iii) es fraudulente, falso, enganoso; (iv) difamatoria, indecente, pornografico, vulgar o ofendivo;(v) promociona descrinimacion, fanatismo, racismo, despecho, acoso o dano contra qualquier individuo o grupo; (vi) es violento o amenazadora o promueve violencia o acciones que son amenazadoras a qualquier persona o entidad; o(vii) promueve ilegal o actividades daninas o sucstacias. 2. Uso, monitora, espejo o marco de servicios, o qualquier elemento individual dentro del  los servicios, ClutchELd  nombre , cualquier  marca comercial  de ClutchELD, el  logo o alguna otra informacion de  propiedad,  o el diseno de cualquier pagina o formulario contenido en una pagina; 3. Acceso, estropear con, o uso de no publico areas de servicios. Sistema de computadoras de ClutchELD, o el Sistema de entrega tecnico de ClutchELD provedores; 4. Atempto de investigar, escanea, o probar la vulnerabilidad de cualquier Sistema, la red o incumplir cualquier seguridad o medidas de autenticacion de ClutchELD.  5. Evitar, eliminar, deactivar, perjudicar, descifrar, o al contrario, evitar cualquier medido de tecnologia implementada por CluthELD o cualquier provedor de ClutchELD o cualquier tercera parte\/persona (incluyendo otro usuario) para protejer el servicio o contenido de usuario; 6. Atempto de acceder o biuscar servicio o contenido de usuario o actualizer contenido de usuario del servicio mediante el uso de cualquier motor, equipo, instrument, agente dispositivo o mecanismo ( incluyendo automata, rastradeores, datos instrumentos mineros o similares) Aparte del software y busqueda de agentes previsto de ClutchELD o algun otro disponible de la tercera parte\/persona de la red navegadores; 7 Enviar cualquier no slicitado o no autorizado  publicidad, promocional, materiales, correo electronicos, basura de correo, correo no deseado, cartas de cadena, o algunas otros formularios de solicitud. 8. Utilizar caulquier metaetiqueta o otro texto oculto o metadatos utiizando a ClutchELD marca comercial, logo, URL o producto sin nombre ClutchELD  consentimiento expreso por escrito. 9. Use el servicio o contenido del usuario para el beneficion de cualquier tercera parte o  cualquier manera no permitida por estos terminus ; 10 Cualquier Fragua TCP\/IP encabezado del paquete o cualquier part de informacion encabezada en cualquier correo electronico o publicacion de grupos de noticias, o en cualquier manera uso de servicio, o contenido de usuario alterado, enganoso o informacion de indentificacion de Fuente falsa. 11. Atempto a descifrar, descompilar, desasemblar Ingeniera inversa cualquier uso de equipo para utilizer para proporcionar los servicios o contenido de usuario; 12. Interferir con  o atempto de interferer con, el acceso de cualquier usuario, anfitrion o red incluyendo, sin limitacion, mandando un virus, sobrecarga, inundacion, spam, o bombardeo de correo de servicios; 13. Colleccion o almacenar cualquier indetificacion personal de informacion de los servicios do otros usuarios del servicio sin su permiso expreso; 14. Impersonar o malrepresentar su afiliacion con cualquier persona o entidad; 15. Violar cualquier ley o regulation aplicable o 16; Alentar o habilitar cualquier otro individuo a cualquiera de los anteriores.",

  "Although we're not obligated to monitor access to or use of the Services or User Content or to review or edit any User Content, we have the right to do so for the purpose of operating the Services, to ensure compliance with these Terms, or to comply with applicable law or other legal requirements. We reserve the right, but are not obligated, to remove or disable access to any User Content, at any time and without notice, including, but not limited to, if we, at our sole discretion, consider any User Content to be objectionable or in violation of these Terms. We have the right to investigate violations of these Terms or conduct that affects the Services. We may also consult and cooperate with law enforcement authorities to prosecute users who violate the law.": "Aunque nosotros no estamos obligados a monitoriar acceso o uso de servicios o contenido de usuario para revisar o editar ningun contenido de usuario, tenemos el derecho para hacerlo con el proposito de operar el servicio, para asegurar cumplimiento de estos terminos, o cumplir con la ley aplicable o otros requerimentos legales. Nosotros reservamos el derecho, pero no estamos obligados, a eliminar deshabilitar  acceso a cualquier contenido de usuario, en cualquier momento o sin aviso, incluido pero no limitado, a nuestra discrecion, considerar a cualquier contenido del usuario sea objetable o en violacion de los terminos. Nosotros tenemos el derecho de investigar las violaciones de estos terminos o cunducta de afectos de servicios. Incluso podemos consultar y coperar con las autoridades policiales para enjuiciar los usuarios que violan la ley.",

  "Termination ClutchELD may terminate your access to and use of the Services, at our sole discretion, at any time and without notice to you. You may cancel your Account at any time by sending an email to us at support@clutcheld.com. Upon any termination, discontinuation or cancellation of Services or your Account, the following provisions will survive: Third Parties; User Content Rights; No Warranty; Indemnity; Limitation of Liability; Choice of Law; Arbitration; and General Terms. At the time of cancellation you will be responsible for any obligations agreed to under the applicable Sales Agreement, to the extent they are validly existing.": "Terminacion Embrague ELD puede terminar su acceso de usar los servicios a nuestra discrecion, en cualquier momento y sin aviso. Usted puede cancelar su cuenta en cualquier momento enviando un correo electronico a \"support@clutcheld.com\". Sobre cualquier terminacion, descontinuacion, o cacelacion de servicios, o su cuenta, las siguientes disposiciones sobreviviran:  Terceras personas: derechos de contenido de usuario; no garantia, indemnisacion;  limitacion de responsabilidad, seleccion de ley, arbitraje, y terminos general. Al  tiempo de cancelacion usted sera responsable por cualquier obligacion de acuerdo de venta aplicable, en la medida en que existan validamente.",

  "No Warranty": "Sin Garantia",

  "THE SERVICES AND USER CONTENT ARE PROVIDED 'AS IS' WITHOUT WARRANTY OF ANY KIND. WITHOUT LIMITING THE FOREGOING, CLUTCHELD EXPLICITLY DISCLAIMS ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT AND NON-INFRINGEMENT AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE. CLUTCHELD EXPLICITLY DISCLAIMS ALL LIABILITY FOR ANY ACT OR OMISSION OF ANY USER OR OTHER THIRD PARTY. WITHOUT LIMITING THE FOREGOING, CLUTCHELD MAKES NO WARRANTY THAT (I) THE SERVICES WILL MEET YOUR REQUIREMENTS OR WILL BE UNINTERRUPTED, TIMELY, SECURE OR ERRORFREE; (II) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICES WILL BE EFFECTIVE, ACCURATE OR RELIABLE; (III) THE QUALITY OF THE SERVICES WILL MEET YOUR EXPECTATIONS; OR THAT (IV) ANY ERRORS OR DEFECTS IN THE SERVICES WILL BE CORRECTED. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM CLUTCHELD OR THROUGH OR FROM USE OF THE SERVICES SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THE TERMS.": "LOS SERVICIOS Y USUARIOS CONTENIDOS SE PROPORCIONAN \"COMO TAL\" SIN GARANTIA DE CUALQUIER TIPO. SIN LIMITAR LO ANTERIOR , CLUTCHELD RENUNCIA EXPLICITAMENTE A CUALQUIER GARANTIA IMPLICTA DE COMERCIABILIDAD, APTITUD PARA UN PROPOSITO PARTICULAR DISFRUTE SILENCIOSO Y NO INFRACCION Y CUALQUIER GARANTIA QUE SURJA DEL CURSO DE LA NEGOCIACION O EL USO DEL COMERCIO. CLUTCHELD RENUNCIA EXPLICITAMENTE A TODO RESPONSABILIDAD POR CUALQUIER ACTO U OMISION DE CUALQUIER USUARIO U OTRA TERCEERA PARTE\/ PERSONA. SIN LIMITAR LO ANTERIOR. CLUTCHELD NO GARANTISA QUE (1) LOS SERVICIOS CUMPLIRAN CON SUS REQUISITOS O SERAN INTERRUMPIDOS, OPORTUNOS, SEGUROS O LIBRES DE ERRORES.(ll) LOS RESULTADOS PUEDEN SER OBTENIDOS DEL USO DE SERVICIOS SERAN EFECTIVOS, PRECISOS O CONFIABLE; (lll) LA CALIDAD DE SERVICIO CUMPLIRA CON SUS EXPECTATIVAS; O QUE(lv) CUALQUIER ERROR O DEFECTOS EN EL SERVICIO SERA CORREJIDO. NO CONSEJO O INFORMACION ,ESCRITO U ORAL, OBTENIDAS POR USTED DE PARTE DE CLUTCHELD O POR MEDIO DEL SERVICIO SE HABRA CREADO CUALQUIER GARANTIA NO EXPRESAMENTE DECLARADA EN LOS TERMINOS",

  "CLUTCHELD IS NOT RESPONSIBLE FOR THE CONDUCT OF ANY USER. YOUR USE OF THE SERVICES IS AT YOUR SOLE RISK AND DISCRETION AND CLUTCHELD HEREBY DISCLAIMS ANY AND ALL LIABILITY TO YOU OR ANY THIRD PARTY RELATING THERETO.": "CLUTCHELD NO ES RESPOSABLE POR LA CONDUCTA DE CUALQUIER USUARIO. SU USO DE SERVICIOS ES A SU EXCLUSIVO RIESGO Y DIRECCION Y CLUTCHELD POR LA PRESENTE RENUNCIA A CUALQUIER Y TODA RESPONSABILIDAD HACIA USTED O CUALQUIEER TERCERO REALACIONADO CON",

  "Indemnity You agree to indemnify, defend and hold harmless ClutchELD and its officers, directors, employees and agents, from and against, all claims, disputes, demands, liabilities, damages, losses, and costs and expenses, including, without limitation, reasonable legal and accounting fees, arising out of or in any way connected with (i) your access to or use of the Services; (ii) your User Content; (iii) your performance of or participation in connection with your use of the Services; or (iv) your violation of these Terms.": "Imdemnidad: Usted esta de acuerdo a indemnizar, defender y mantener inofensiva a ClutchELD y sus oficiales, directores, empleados y agentes, desde y contra, todo reclamo, disputas, de mandas, deudas, danos, perdidas y costos y gastos, incluido y sin limitaciones, responsables legales y honorarios de contabilidad, que surja de o de alguna manera relacionada con(1) su acceso  de usar los servicios; (ii) su contenido del usuario; (iii)su actuacion de o participar en connecion de uso de servicios; o (iv) su violacion de estos terminos.",

  "Limitation of Liability": "Limitacion de responsabilida",

  "NEITHER CLUTCHELD NOR ANY OTHER PARTY INVOLVED IN CREATING, PRODUCING, OR DELIVERING THE SERVICES OR USER CONTENT WILL BE LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS, LOSS OF DATA OR GOODWILL, SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST OF SUBSTITUTE SERVICES ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO USE THE SERVICES OR USER CONTENT, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT CLUTCHELD HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU.": "NINGUN EMBRAGUE ELD O CUALQUIER OTRA PERSONA INVOLUCRADA CREANDO, PRODUCIENDO O ENTREGANDO SERVICIOS O CONTENIDO DE USUARIO SERA RESPONSIBLE POR CUALQUIER INCIDENTE, ESPECIAL, EJEMPLAR O DANOS GENERADOS, INCLUYENDO PERDIDAS DE GANANCIAS, PERDIDA DE DATOS O BUENA VOLUNTAD, INTERUPCION DE SERVICIO, DANOS DE COMPUTADORA O FALLIDO DE SISTEMA O EL COSTO DE SERVICIOS, SUSTITUIDOS  SERVICIOS",

  "CLUTCHELD WILL NOT BE LIABLE TO YOU UNDER ANY CIRCUMSTANCES ARISING OUT OF THE MISUSE OF YOUR USER CONTENT BY THIRD PARTIES INCLUDING, WITHOUT LIMITATION, OTHER USERS.": "CLUTCHELD NO ES RESPONSABLE POR LA CONDUCTA DE CUALQUIER USUARIO. SU USO DE SERVICIOS ES A SU EXCLUSIVO RIESGO Y DIRECCION Y CLUTCHELD POR LA PRESENTE RENUNCIA A CUALQUIER Y TODA RESPONSABILIDAD HACIA USTED O CUALQUIEER TERCERO REALACIONADO CON",

  "In no event will ClutchELD's total liability arising out of or in connection with these terms or from the use of or inability to use the Services or User Content exceed fifty dollars ($50), or the amount paid by you to ClutchELD during the preceding six (6) month period for use of the Services, whichever is greater.": "En cualquier evento ClutchELD responsabilidades total surgiendo fuera o en conecion con estos terminos o del uso de inabilidad de usar servicios o contenido de usuario excede $50 dolares el monto pagado por usted a ClutchELD durante anterior seis meses de periodo o usos de los servicios o cualquier sea meyor.",

  "Choice of Law; Arbitration This Agreement is subject to the law of the State of Texas, United States, without regard to choice or conflicts of law principles. Further, you agree to the exclusive jurisdiction of the state and federal courts in Harris County, Texas to resolve any dispute, claim or controversy that arises in connection with this Agreement.": "Eleccion de ley; Arbitracion de este acuerdo is subjeto a la ley del Estado de Texas, United States, sin consideracion de escojer o conflictos de la ley principals. Ademas esta de acuerdo  al exclusive jurisdiccion del estado y cortes federales en el condado de Harris, Texas,  para resolver cualquier disputa, reclamo o controversia que surja en coneccion de este acuerdo.",

  "The following mandatory arbitration provisions also apply to you:": "Las siguentes disposiciones de arbitraje obligatorio Tambien se aplican a usted:",

  "1. You and ClutchELD agree that any dispute, claim or controversy arising out of or relating in any way to the ClutchELD Service or your use thereof, including our Agreements, shall be determined by mandatory binding arbitration. You and ClutchELD are each waiving the right to a trial by jury and the right to participate in a class or multi-party action. This arbitration provision shall survive": "1.Usted y ClutchELD  acuerdan que cualquier disputa, reclamo o controveria surgiendo fuera de o relacionado en cualquier manera a CluctchELD Servicio o su uso de, incluyendo nuestro acuerdo, sera determinado por mandatorio vinculante arbitracion. Usted y ClutchELD renunciant el derecho  a un juicio por Jurado y el derecho a prticipar en una clase o multi – parte de accion este arbitracion provicion sobrevivira",

  "termination of these Agreements and the termination of your account with ClutchELD. The arbitration will be governed by the American Arbitration Association (the “AAA Rules”), as modified by this Agreement, and as administered by the AAA. You and ClutchELD agree that this Agreement may involve interstate commerce and may be subject to the Federal Arbitration Act. 2. Any arbitration must be commenced by filing a demand for arbitration with the AAA within ONE (1) YEAR after the date the party asserting the claim first knows or reasonably should know of the act, omission or default giving rise to the claim; and there shall be no right to any remedy for any claim not asserted within that time period. If applicable law prohibits a one-year limitations period for asserting claims, any claim must be asserted within the shortest time period permitted by applicable law. The findings of the arbitrator shall be final and binding on the parties, and may be entered in any court of competent jurisdiction for enforcement. Notwithstanding the law of Texas, legal fees shall be awarded to the prevailing party in the arbitration.": "Cualquier Arbitracion debe comenzar por archivando una demanda para arbitracion con AAA durante un (1) ano despues de la fecha la parte que hace valer el reclamo primero sabe o conocer de manera razonable el acto, omicion o incumplimiento que da lugar a la reclamacion: y no habra derecho a cualquier remedio para ningun reclamono asertado dentro de ese periodo de tiempo. Si la ley applicable prohibe un periodo de limitaciones de un ano para hacer valer reclamaciones. Cualquier reclamo debe hacerse dentro del period de tiempo mas corto permitido por la ley aplicable. Las conclusions del arbitro seran definitivas y vinculantes para las partes, y se puede inresar en cualquir tribunal de jurisdiccion competente para la ejucacion. Sin perjuicio de la ley de Texas, los honrarios legales se otorgaran a la parte ganadora en el arbitraje.",

  "General Terms These Terms constitute the entire and exclusive understanding and agreement between ClutchELD and you regarding the Services and User Content, and these Terms supersede and replace any and all prior oral or written understandings or agreements between ClutchELD and you regarding the Services and User Content. If for any reason a court of competent jurisdiction finds any provision of these Terms invalid or unenforceable, that provision will be enforced to the maximum extent permissible and the other provisions of these Terms will remain in full force and effect.": "Terminos Generales, Estos Terminos constituyen el entendimiento y acuerdo complete y exclusive entre ClutchELD Y usted sobre los servicios y el contenido del usuario, estos terminus reemplazan cualquier y todo anterior oral o escrito entendimientos o acuerdos entre ClutchELD y usted sobre los servicios y el contenido del usuario. Si por alguna razon alguna corte de competencia jurisdiccion encuentra cualquier provision de estos terminus invalido o inapplicable , esa provision sera ejecutada al maximo medida permissible y las otras disposiciones de estos terminus permanecran en pleno vigor y efecto.",

  "You may not assign or transfer these Terms, by operation of law or otherwise, without ClutchELD's prior written consent. Any attempt by you to assign or transfer these Terms, without such consent, will be null and of no effect. ClutchELD may freely assign or transfer these Terms without restriction. Subject to the foregoing, these Terms will bind and inure to the benefit of the parties, their successors and permitted assigns": "No debe asignar o transferir estos terminos, por aplicacion de la ley o lo contrario, sin embrague ELD consentimiento previo por escrito. Tal atempto de asignar o transferir estos terminos sin consentimiento, seran anulado sin ningun efecto. Ebrague ELD puede asignar libremente o transferir estos terminos sin restricciones. Sujeto a lo anterioe, estos terminos seran vinculados y asegurados por las personas, sus sucesores y cesionarios autorizados",

  "Any notices or other communications provided by ClutchELD under these Terms, including those regarding modifications to these Terms, will be given by ClutchELD via email. For notices made by e-mail, the date of receipt will be deemed the date on which such notice is transmitted.": "Cualquier aviso o alguna otra comunicacion prevista por Emprague ELD bajo estos Terminos, incluidos los relacionados con modificaciones para estos Terminos seran dados por Embrague ELD via correo electronico. Avisos hechos por correo electronicos, fecha de reicicimiento se considerara, fecha en cual este aviso sera transmitido",

  "ClutchELD's failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. The waiver of any such right or provision will be effective only if in writing and signed by a duly authorized representative of ClutchELD. Except as expressly set forth in these Terms, the exercise by either party of any of its remedies under these Terms will be without prejudice to its other remedies under these Terms or otherwise.": "Embrague ELD fracaso de endorsar qualquier derecho o provicion de estos Terminos no seran considerados a una renucia de esos derechos. La renuncioa de tal derecho o provicion sera efecto solamente por escrito y firmado debidamente autorizada por un representante del Embrague ELD.  Con la execpcion. Salvo que se establezca expresamente en estos terminos. El ejercicio por cualquiera de las partes de cualquier recurso bajo estos Terminos sin prejuicios a sus remedios bajo estos terminos de lo contrario",

  "Contract Length (Years)": "Duracion del contrato (anos)",

  "Fleet Drivers": "Conductores de flota",

  "Fleet Vehicles": "Vehículos de flota",

  "Report From Gorilla": "Informes de Gorilla",

  "Hello, there is document for you!": "Hola, hay un documento para usted",

  "Please contact your fleet manager about enabling the messaging feature.": "Contactar a su gerente de flota sobre la habilitacion de la funcion de mensajeria",

  "Vehicle Coordinates saved successfully": "Coordenadas de vehiculo se guardaron exitosamente",

  "Unauthorized": "Solicitud de servicio asignada a un centro de servicio. Incapaz de hacer este cambio",

  "Reports From Fleetlocate": "Informes de ubicacion de flota",

  "Hello, there are some docs for you!": "Hola, hay unos documentos para usted",

  "Bad Request": "Solicitudes incorrectas",

  "Exception occured": "Ocurrio una excepcion de tarjeta.",

  "Failed to assign Co-driver": "No pudo asignar copiloto",

  "No Content": "No contenido",

  "Event type is mandatory.": "Tipo de evento es mandatorio",

  "Event date and time is mandatory.": "Fecha y hora de evento es mandatorio",

  "Driver Id is mandatory.": "Identificacion de conductor es mandatorio",

  "Driver Id should be numeric": "Identificacion de conductor debe ser de numeracion",

  "Vehicle Id is mandatory.": "Identificacion de vehiculo es mandatorio",

  "Vehicle Id should be numeric": "Identificacion de vehiculo debe ser numeracion",

  "Hardware type is mandatory.": "Tipo de equipo es mandatorio",

  "Company found": "Empresa encontrada",

  "No companies found": "No se encuentran empresas",

  "failure": "Fallido",

  "No vehicle assigned for the user": "No se encuentra usuario asignado a este vehiculo",

  "Logged in Successfully": "Actualizado exitosamente",

  "Please enter a registered email address": "Ingrese un correo electronico registrado",

  "Your login is already in use, do you want to logout another user and login?": "Su acceso esta en uso, Quiere cerrar la sesion de otro usuario e iniciar session?",

  "User does not exist in the system.": "Usuario no existe en el sistema",

  "Pending requests for mobile debug log does not exist for User User1": "Solicitudes pendientes para el rgistro de ddepuracion movil no existe para el usuario, usuario 1",

  "Mobile debug logs request does not exist for user.": "La solicitud de depuracion movil no existe para el usuario",

  "Successfully Added The Parts": "Se agregaron piezas exitosamente",

  "Rated Successfully": "Calificado exitosamente",

  "No such vehicle": "No hay tal vehiculo",

  "Approval": "Aprobado",

  "Co drivers": "Copilotos",

  "Bad date format": "Formato de fecha incorrecto",

  "WorkOrder not found for this user and id": "No se encuentra trabajo de peido para esta identificacion del usuario",

  "There was an issue retrieving this file. Please try again later.": "Hubo un problema al recuperar este archivo, intentelo de nuevo.",

  "An error occurred while sending logs": "Se produjo un error al enviar los registros",

  "Indicates out of service": "Indica fuera de servicio",

  "Add Trailer remarks": "Agregar un comentario al trailer",

  "Select Trailer": "Seleccionar trailer",

  "Trailer not selected": "Trailer no seleccionado",

  "Select the trailer with the marked defect to finish inspection.": "Seleccione el remolque con el defecto marcado para finalizar la inspeccion.",

  "Trailer condition not selected": "Condicion del remolque no seleccionada.",

  "Select one of the trailer conditions to finish inspection.": "Seleccione una de las condiciones del remolque para finalizar la inspeccion.",

  "Do you wish to mark all the unmarked parts as OK?": "Desea marcar todas las partes no seleccionadas como correctas?",

  "The following vehicle was repaired": "El siguiente vehiculo fue reparado",

  "Finish": "Terminar",

  "Please sign all policies and procedures.": "Por favor firme todas las polizas y procedimientos.",

  "Add New Vehicle": "Agregar un nuevo vehiculo",

  "UNIT ID": "Identificación de la unidad",

  "VIN": "VIN",

  "MAKE": "Marca",

  "PLATE NUMBER": "Numero de placa",

  "CURRENT ODOMETER": "Cuentakilometros actual",

  "GVW": "GVW or Peso total de vehículo",

  "NEXT MAINTENANCE DAY": "Proximo dia de mantenimiento",

  "NOTES": "Notas",

  "ELD SERIAL NUMBER": "Numero de seria del ELD",

  "HARDWARE TYPE": "Tipo de hardware",

  "ELD TYPE": "Tipo de ELD",

  "YEAR": "Ano",

  "MODEL": "Modelo",

  "Select Vehicle Type": "Seleccione el tipo de vehiculo",

  "Select Hardware Type": "Seleccione el tipo de hardware",

  "Select ELD TYPE": "Seleccione el tipo de ELD",

  "Fixed": "Reparado",

  "Cannot mark as complete until all defects are fixed.": "No se puede marcar como completo hasta que se hayan solucionado todos los defectos.",

  "Please approve or reject all defect fixes before submitting review.": "Apruebe o rechace todas las correcciones de defectos antes de enviar la revision.",

  "Due to no internet connectivity, accident report will be sent later": "Debido a que no hay conexion a internet, el informe del accidente se enviara mas tarde.",

  "Accident report was successfully sent": "El informe de accidente se envio con exito",

  "ADD PARTY INVOLVED": "Agregar parte involucrada",

  "TYPE": "Tipo",

  "FULL NAME": "Nombre completo",

  "PHONE": "Numero de telefono",

  "STATE": "Estado",

  "CITY": "Ciudad",

  "ADDRESS": "Direccion",

  "INSURANCE INFORMATION": "Informaccion del seguro",

  "Audio statement": "Declaracion de audio",

  "BROADVIEW": "Vista General",

  "BROADVIEW 2": "Vista General 2",

  "DRIVER FRONT": "Conductor en frente",

  "PASSENGER FRONT": "Pasajero en frente",

  "DRIVER REAR": "Lado de conductor trasero",

  "PASSENGER REAR": "Lado de pasajero trasero",

  "OTHER VEHICLE AND PROPERTY DAMAGE": "Otro vehiculo y propiedad danada",

  "Other Driver": "Otro conductor",

  "Passenger": "Pasajero",

  "Passenger of Other Vehicle": "Pasajeros de orto vehiculo",

  "Witness": "Testigo",

  "Firmware Update available!": "Actualizacion de firmware disponible.",

  "Tap on the Firmware Update Button in ELD Info screen": "Toque el boton de actualizacion de Firmware en la pantalla de informacion.",

  "Service Type": "Tipo de servicio",

  "You are not connected to the Internet. You can only view downloaded work orders.": "No esta conectado a Internet.  Solo puede ver las ordenes de trabajo descargadas.",

  "Home": "Pagina de inicio",

  "Trailer Compliant With 396 Regulations?": "El trailer cumple con regulaciones?",

  "Enter Unit id or VIN number": "Ingrese la identificacion de la unidad o el numero de identificacion del vehiculo.",

  "Sorry no trailer found": "Lo siento, no se ha encontrado ningun trailer",

  "Edit Signature": "Editar firma",

  "Driver goes over his/her driving hours": "El conductor supera sus horas de manejo",

  "Driver goes over his/her duty hours": "El conductor supera sus horas de servicio",

  "Driver goes over his/her cycle hours": "El conductor supera sus horas de su ciclo de manejo",

  "Driver has not taken a break or break was too short": "El conductor no ha tomado un descanso o el descanso fue demasiado corto",

  "Send Feedback": "Enviar comentarios",

  "There is an unidentified driver on the ELD.": "Hay una conductor no identificado en el ELD",

  "Drop a file here or click to upload": "Suelte un archivo aquí o haga clic para cargar",

  "%s ELD has identified a data diagnostic event. The %s ELD Diagnostic Event is %s.": "ELD ha identificado un evento de diognostico de datos.  El evento diognostico es.."
}
